// Generated from java-escape by ANTLR 4.11.1
// jshint ignore: start
import antlr4 from 'antlr4';
import sequenceParserListener from './sequenceParserListener.js';
const serializedATN = [4,1,76,658,2,0,7,0,2,1,7,1,2,2,7,2,2,3,7,3,2,4,7,
4,2,5,7,5,2,6,7,6,2,7,7,7,2,8,7,8,2,9,7,9,2,10,7,10,2,11,7,11,2,12,7,12,
2,13,7,13,2,14,7,14,2,15,7,15,2,16,7,16,2,17,7,17,2,18,7,18,2,19,7,19,2,
20,7,20,2,21,7,21,2,22,7,22,2,23,7,23,2,24,7,24,2,25,7,25,2,26,7,26,2,27,
7,27,2,28,7,28,2,29,7,29,2,30,7,30,2,31,7,31,2,32,7,32,2,33,7,33,2,34,7,
34,2,35,7,35,2,36,7,36,2,37,7,37,2,38,7,38,2,39,7,39,2,40,7,40,2,41,7,41,
2,42,7,42,2,43,7,43,2,44,7,44,2,45,7,45,2,46,7,46,2,47,7,47,2,48,7,48,2,
49,7,49,2,50,7,50,2,51,7,51,2,52,7,52,2,53,7,53,2,54,7,54,2,55,7,55,2,56,
7,56,2,57,7,57,2,58,7,58,2,59,7,59,2,60,7,60,1,0,3,0,124,8,0,1,0,1,0,3,0,
128,8,0,1,0,1,0,1,0,1,0,3,0,134,8,0,1,0,3,0,137,8,0,1,0,1,0,1,0,3,0,142,
8,0,1,1,1,1,3,1,146,8,1,1,1,3,1,149,8,1,1,2,1,2,4,2,153,8,2,11,2,12,2,154,
1,2,1,2,5,2,159,8,2,10,2,12,2,162,9,2,1,2,3,2,165,8,2,1,3,1,3,3,3,169,8,
3,1,3,1,3,5,3,173,8,3,10,3,12,3,176,9,3,1,3,3,3,179,8,3,3,3,181,8,3,1,4,
1,4,1,4,3,4,186,8,4,1,4,3,4,189,8,4,1,4,3,4,192,8,4,1,5,1,5,1,6,3,6,197,
8,6,1,6,3,6,200,8,6,1,6,3,6,203,8,6,1,6,1,6,3,6,207,8,6,1,6,3,6,210,8,6,
1,6,3,6,213,8,6,1,6,1,6,3,6,217,8,6,1,7,1,7,1,7,1,7,1,7,1,7,1,7,3,7,226,
8,7,1,7,1,7,3,7,230,8,7,3,7,232,8,7,1,8,1,8,1,8,3,8,237,8,8,1,9,1,9,1,10,
1,10,1,11,1,11,1,12,1,12,1,12,1,12,1,12,3,12,250,8,12,1,13,4,13,253,8,13,
11,13,12,13,254,1,14,1,14,3,14,259,8,14,1,14,3,14,262,8,14,1,14,1,14,1,14,
3,14,267,8,14,1,14,1,14,3,14,271,8,14,3,14,273,8,14,1,15,1,15,1,15,1,15,
1,15,3,15,280,8,15,1,15,1,15,1,15,3,15,285,8,15,3,15,287,8,15,1,16,1,16,
1,17,1,17,1,18,1,18,1,18,1,18,1,18,1,18,1,18,1,18,1,18,1,18,1,18,3,18,304,
8,18,1,18,1,18,1,18,3,18,309,8,18,1,19,1,19,3,19,313,8,19,1,19,1,19,3,19,
317,8,19,1,20,1,20,3,20,321,8,20,1,20,1,20,3,20,325,8,20,1,21,1,21,3,21,
329,8,21,1,21,1,21,3,21,333,8,21,1,22,1,22,1,22,3,22,338,8,22,1,22,3,22,
341,8,22,1,22,1,22,1,22,3,22,346,8,22,1,23,1,23,1,23,3,23,351,8,23,1,24,
1,24,1,24,1,24,1,24,5,24,358,8,24,10,24,12,24,361,9,24,5,24,363,8,24,10,
24,12,24,366,9,24,1,24,1,24,3,24,370,8,24,1,25,3,25,373,8,25,1,25,1,25,1,
25,1,25,3,25,379,8,25,1,25,3,25,382,8,25,1,25,3,25,385,8,25,1,25,3,25,388,
8,25,1,26,1,26,1,26,3,26,393,8,26,1,27,1,27,1,27,3,27,398,8,27,1,27,3,27,
401,8,27,1,27,1,27,3,27,405,8,27,1,27,3,27,408,8,27,1,28,1,28,1,28,3,28,
413,8,28,1,28,1,28,1,28,1,29,1,29,1,29,5,29,421,8,29,10,29,12,29,424,9,29,
1,30,3,30,427,8,30,1,30,1,30,1,31,3,31,432,8,31,1,31,1,31,1,32,1,32,3,32,
438,8,32,1,33,1,33,3,33,442,8,33,1,33,1,33,1,34,3,34,447,8,34,1,34,1,34,
1,34,1,35,1,35,1,35,3,35,455,8,35,1,35,1,35,1,35,3,35,460,8,35,1,35,1,35,
1,35,3,35,465,8,35,3,35,467,8,35,1,36,1,36,1,37,1,37,1,38,1,38,1,39,1,39,
1,39,1,39,5,39,479,8,39,10,39,12,39,482,9,39,1,39,1,39,1,39,3,39,487,8,39,
1,40,3,40,490,8,40,1,40,1,40,1,41,1,41,1,41,5,41,497,8,41,10,41,12,41,500,
9,41,1,41,3,41,503,8,41,1,42,1,42,1,42,3,42,508,8,42,1,43,1,43,1,43,3,43,
513,8,43,1,44,1,44,1,44,1,45,1,45,5,45,520,8,45,10,45,12,45,523,9,45,1,45,
3,45,526,8,45,1,46,1,46,1,46,1,47,1,47,3,47,533,8,47,1,47,1,47,1,48,1,48,
1,48,1,49,1,49,5,49,542,8,49,10,49,12,49,545,9,49,1,49,3,49,548,8,49,1,50,
1,50,1,50,3,50,553,8,50,1,51,1,51,1,51,1,51,3,51,559,8,51,1,52,1,52,3,52,
563,8,52,1,53,1,53,3,53,567,8,53,1,53,1,53,1,54,1,54,3,54,573,8,54,1,54,
3,54,576,8,54,1,55,1,55,1,55,1,55,1,55,1,55,1,55,1,55,1,55,3,55,587,8,55,
1,55,1,55,1,55,1,55,1,55,1,55,1,55,1,55,1,55,3,55,598,8,55,1,55,1,55,1,55,
1,55,1,55,1,55,1,55,1,55,1,55,1,55,1,55,1,55,1,55,1,55,1,55,1,55,1,55,1,
55,1,55,1,55,1,55,5,55,621,8,55,10,55,12,55,624,9,55,1,56,1,56,1,56,1,56,
1,56,1,56,1,56,1,56,3,56,634,8,56,1,57,1,57,3,57,638,8,57,1,57,3,57,641,
8,57,1,58,1,58,1,58,1,58,3,58,647,8,58,1,59,1,59,1,59,1,59,1,60,4,60,654,
8,60,11,60,12,60,655,1,60,0,1,110,61,0,2,4,6,8,10,12,14,16,18,20,22,24,26,
28,30,32,34,36,38,40,42,44,46,48,50,52,54,56,58,60,62,64,66,68,70,72,74,
76,78,80,82,84,86,88,90,92,94,96,98,100,102,104,106,108,110,112,114,116,
118,120,0,13,2,0,8,8,20,20,2,0,9,9,19,19,2,0,60,60,65,67,2,0,11,11,24,24,
2,0,60,60,65,65,1,0,25,27,1,0,23,24,1,0,19,22,1,0,17,18,1,0,61,62,1,0,37,
38,1,0,66,67,2,0,60,60,64,65,741,0,141,1,0,0,0,2,143,1,0,0,0,4,164,1,0,0,
0,6,166,1,0,0,0,8,191,1,0,0,0,10,193,1,0,0,0,12,216,1,0,0,0,14,231,1,0,0,
0,16,236,1,0,0,0,18,238,1,0,0,0,20,240,1,0,0,0,22,242,1,0,0,0,24,249,1,0,
0,0,26,252,1,0,0,0,28,272,1,0,0,0,30,286,1,0,0,0,32,288,1,0,0,0,34,290,1,
0,0,0,36,308,1,0,0,0,38,316,1,0,0,0,40,324,1,0,0,0,42,332,1,0,0,0,44,345,
1,0,0,0,46,347,1,0,0,0,48,352,1,0,0,0,50,387,1,0,0,0,52,389,1,0,0,0,54,407,
1,0,0,0,56,412,1,0,0,0,58,417,1,0,0,0,60,426,1,0,0,0,62,431,1,0,0,0,64,435,
1,0,0,0,66,439,1,0,0,0,68,446,1,0,0,0,70,466,1,0,0,0,72,468,1,0,0,0,74,470,
1,0,0,0,76,472,1,0,0,0,78,486,1,0,0,0,80,489,1,0,0,0,82,493,1,0,0,0,84,507,
1,0,0,0,86,509,1,0,0,0,88,514,1,0,0,0,90,517,1,0,0,0,92,527,1,0,0,0,94,530,
1,0,0,0,96,536,1,0,0,0,98,539,1,0,0,0,100,549,1,0,0,0,102,554,1,0,0,0,104,
560,1,0,0,0,106,564,1,0,0,0,108,570,1,0,0,0,110,597,1,0,0,0,112,633,1,0,
0,0,114,635,1,0,0,0,116,646,1,0,0,0,118,648,1,0,0,0,120,653,1,0,0,0,122,
124,3,2,1,0,123,122,1,0,0,0,123,124,1,0,0,0,124,125,1,0,0,0,125,142,5,0,
0,1,126,128,3,2,1,0,127,126,1,0,0,0,127,128,1,0,0,0,128,129,1,0,0,0,129,
130,3,4,2,0,130,131,5,0,0,1,131,142,1,0,0,0,132,134,3,2,1,0,133,132,1,0,
0,0,133,134,1,0,0,0,134,136,1,0,0,0,135,137,3,4,2,0,136,135,1,0,0,0,136,
137,1,0,0,0,137,138,1,0,0,0,138,139,3,26,13,0,139,140,5,0,0,1,140,142,1,
0,0,0,141,123,1,0,0,0,141,127,1,0,0,0,141,133,1,0,0,0,142,1,1,0,0,0,143,
145,5,6,0,0,144,146,5,74,0,0,145,144,1,0,0,0,145,146,1,0,0,0,146,148,1,0,
0,0,147,149,5,75,0,0,148,147,1,0,0,0,148,149,1,0,0,0,149,3,1,0,0,0,150,153,
3,6,3,0,151,153,3,12,6,0,152,150,1,0,0,0,152,151,1,0,0,0,153,154,1,0,0,0,
154,152,1,0,0,0,154,155,1,0,0,0,155,165,1,0,0,0,156,159,3,6,3,0,157,159,
3,12,6,0,158,156,1,0,0,0,158,157,1,0,0,0,159,162,1,0,0,0,160,158,1,0,0,0,
160,161,1,0,0,0,161,163,1,0,0,0,162,160,1,0,0,0,163,165,3,8,4,0,164,152,
1,0,0,0,164,160,1,0,0,0,165,5,1,0,0,0,166,168,5,46,0,0,167,169,3,20,10,0,
168,167,1,0,0,0,168,169,1,0,0,0,169,180,1,0,0,0,170,174,5,35,0,0,171,173,
3,12,6,0,172,171,1,0,0,0,173,176,1,0,0,0,174,172,1,0,0,0,174,175,1,0,0,0,
175,178,1,0,0,0,176,174,1,0,0,0,177,179,5,36,0,0,178,177,1,0,0,0,178,179,
1,0,0,0,179,181,1,0,0,0,180,170,1,0,0,0,180,181,1,0,0,0,181,7,1,0,0,0,182,
188,5,56,0,0,183,185,5,33,0,0,184,186,3,10,5,0,185,184,1,0,0,0,185,186,1,
0,0,0,186,187,1,0,0,0,187,189,5,34,0,0,188,183,1,0,0,0,188,189,1,0,0,0,189,
192,1,0,0,0,190,192,5,58,0,0,191,182,1,0,0,0,191,190,1,0,0,0,192,9,1,0,0,
0,193,194,3,20,10,0,194,11,1,0,0,0,195,197,3,18,9,0,196,195,1,0,0,0,196,
197,1,0,0,0,197,199,1,0,0,0,198,200,3,14,7,0,199,198,1,0,0,0,199,200,1,0,
0,0,200,202,1,0,0,0,201,203,3,24,12,0,202,201,1,0,0,0,202,203,1,0,0,0,203,
204,1,0,0,0,204,206,3,20,10,0,205,207,3,22,11,0,206,205,1,0,0,0,206,207,
1,0,0,0,207,209,1,0,0,0,208,210,3,16,8,0,209,208,1,0,0,0,209,210,1,0,0,0,
210,212,1,0,0,0,211,213,5,12,0,0,212,211,1,0,0,0,212,213,1,0,0,0,213,217,
1,0,0,0,214,217,3,14,7,0,215,217,3,18,9,0,216,196,1,0,0,0,216,214,1,0,0,
0,216,215,1,0,0,0,217,13,1,0,0,0,218,219,5,8,0,0,219,220,3,20,10,0,220,221,
5,9,0,0,221,232,1,0,0,0,222,223,5,8,0,0,223,225,3,20,10,0,224,226,5,19,0,
0,225,224,1,0,0,0,225,226,1,0,0,0,226,232,1,0,0,0,227,229,7,0,0,0,228,230,
7,1,0,0,229,228,1,0,0,0,229,230,1,0,0,0,230,232,1,0,0,0,231,218,1,0,0,0,
231,222,1,0,0,0,231,227,1,0,0,0,232,15,1,0,0,0,233,234,5,51,0,0,234,237,
3,20,10,0,235,237,5,51,0,0,236,233,1,0,0,0,236,235,1,0,0,0,237,17,1,0,0,
0,238,239,5,58,0,0,239,19,1,0,0,0,240,241,7,2,0,0,241,21,1,0,0,0,242,243,
5,61,0,0,243,23,1,0,0,0,244,245,5,13,0,0,245,246,3,20,10,0,246,247,5,14,
0,0,247,250,1,0,0,0,248,250,5,76,0,0,249,244,1,0,0,0,249,248,1,0,0,0,250,
25,1,0,0,0,251,253,3,36,18,0,252,251,1,0,0,0,253,254,1,0,0,0,254,252,1,0,
0,0,254,255,1,0,0,0,255,27,1,0,0,0,256,258,5,43,0,0,257,259,3,110,55,0,258,
257,1,0,0,0,258,259,1,0,0,0,259,261,1,0,0,0,260,262,5,30,0,0,261,260,1,0,
0,0,261,262,1,0,0,0,262,273,1,0,0,0,263,264,5,57,0,0,264,266,3,70,35,0,265,
267,5,73,0,0,266,265,1,0,0,0,266,267,1,0,0,0,267,273,1,0,0,0,268,270,3,30,
15,0,269,271,5,73,0,0,270,269,1,0,0,0,270,271,1,0,0,0,271,273,1,0,0,0,272,
256,1,0,0,0,272,263,1,0,0,0,272,268,1,0,0,0,273,29,1,0,0,0,274,275,3,60,
30,0,275,276,5,10,0,0,276,277,3,62,31,0,277,279,5,7,0,0,278,280,3,72,36,
0,279,278,1,0,0,0,279,280,1,0,0,0,280,287,1,0,0,0,281,282,3,60,30,0,282,
284,5,10,0,0,283,285,3,62,31,0,284,283,1,0,0,0,284,285,1,0,0,0,285,287,1,
0,0,0,286,274,1,0,0,0,286,281,1,0,0,0,287,31,1,0,0,0,288,289,3,34,17,0,289,
33,1,0,0,0,290,291,5,71,0,0,291,35,1,0,0,0,292,309,3,98,49,0,293,309,3,38,
19,0,294,309,3,40,20,0,295,309,3,42,21,0,296,309,3,44,22,0,297,309,3,48,
24,0,298,309,3,108,54,0,299,309,3,46,23,0,300,309,3,52,26,0,301,303,3,70,
35,0,302,304,5,73,0,0,303,302,1,0,0,0,303,304,1,0,0,0,304,309,1,0,0,0,305,
309,3,28,14,0,306,309,3,32,16,0,307,309,3,90,45,0,308,292,1,0,0,0,308,293,
1,0,0,0,308,294,1,0,0,0,308,295,1,0,0,0,308,296,1,0,0,0,308,297,1,0,0,0,
308,298,1,0,0,0,308,299,1,0,0,0,308,300,1,0,0,0,308,301,1,0,0,0,308,305,
1,0,0,0,308,306,1,0,0,0,308,307,1,0,0,0,309,37,1,0,0,0,310,312,5,45,0,0,
311,313,3,114,57,0,312,311,1,0,0,0,312,313,1,0,0,0,313,314,1,0,0,0,314,317,
3,106,53,0,315,317,5,45,0,0,316,310,1,0,0,0,316,315,1,0,0,0,317,39,1,0,0,
0,318,320,5,47,0,0,319,321,3,114,57,0,320,319,1,0,0,0,320,321,1,0,0,0,321,
322,1,0,0,0,322,325,3,106,53,0,323,325,5,47,0,0,324,318,1,0,0,0,324,323,
1,0,0,0,325,41,1,0,0,0,326,328,5,48,0,0,327,329,3,114,57,0,328,327,1,0,0,
0,328,329,1,0,0,0,329,330,1,0,0,0,330,333,3,106,53,0,331,333,5,48,0,0,332,
326,1,0,0,0,332,331,1,0,0,0,333,43,1,0,0,0,334,340,5,49,0,0,335,337,5,33,
0,0,336,338,3,112,56,0,337,336,1,0,0,0,337,338,1,0,0,0,338,339,1,0,0,0,339,
341,5,34,0,0,340,335,1,0,0,0,340,341,1,0,0,0,341,342,1,0,0,0,342,346,3,106,
53,0,343,346,3,106,53,0,344,346,5,49,0,0,345,334,1,0,0,0,345,343,1,0,0,0,
345,344,1,0,0,0,346,45,1,0,0,0,347,350,3,50,25,0,348,351,5,30,0,0,349,351,
3,106,53,0,350,348,1,0,0,0,350,349,1,0,0,0,350,351,1,0,0,0,351,47,1,0,0,
0,352,353,5,50,0,0,353,354,5,33,0,0,354,364,3,20,10,0,355,359,5,31,0,0,356,
358,3,20,10,0,357,356,1,0,0,0,358,361,1,0,0,0,359,357,1,0,0,0,359,360,1,
0,0,0,360,363,1,0,0,0,361,359,1,0,0,0,362,355,1,0,0,0,363,366,1,0,0,0,364,
362,1,0,0,0,364,365,1,0,0,0,365,367,1,0,0,0,366,364,1,0,0,0,367,369,5,34,
0,0,368,370,5,30,0,0,369,368,1,0,0,0,369,370,1,0,0,0,370,49,1,0,0,0,371,
373,3,68,34,0,372,371,1,0,0,0,372,373,1,0,0,0,373,374,1,0,0,0,374,375,5,
44,0,0,375,381,3,74,37,0,376,378,5,33,0,0,377,379,3,82,41,0,378,377,1,0,
0,0,378,379,1,0,0,0,379,380,1,0,0,0,380,382,5,34,0,0,381,376,1,0,0,0,381,
382,1,0,0,0,382,388,1,0,0,0,383,385,3,68,34,0,384,383,1,0,0,0,384,385,1,
0,0,0,385,386,1,0,0,0,386,388,5,44,0,0,387,372,1,0,0,0,387,384,1,0,0,0,388,
51,1,0,0,0,389,392,3,54,27,0,390,393,5,30,0,0,391,393,3,106,53,0,392,390,
1,0,0,0,392,391,1,0,0,0,392,393,1,0,0,0,393,53,1,0,0,0,394,400,3,68,34,0,
395,397,3,56,28,0,396,398,3,58,29,0,397,396,1,0,0,0,397,398,1,0,0,0,398,
401,1,0,0,0,399,401,3,58,29,0,400,395,1,0,0,0,400,399,1,0,0,0,400,401,1,
0,0,0,401,408,1,0,0,0,402,404,3,56,28,0,403,405,3,58,29,0,404,403,1,0,0,
0,404,405,1,0,0,0,405,408,1,0,0,0,406,408,3,58,29,0,407,394,1,0,0,0,407,
402,1,0,0,0,407,406,1,0,0,0,408,55,1,0,0,0,409,410,3,60,30,0,410,411,5,11,
0,0,411,413,1,0,0,0,412,409,1,0,0,0,412,413,1,0,0,0,413,414,1,0,0,0,414,
415,3,62,31,0,415,416,5,59,0,0,416,57,1,0,0,0,417,422,3,64,32,0,418,419,
5,59,0,0,419,421,3,64,32,0,420,418,1,0,0,0,421,424,1,0,0,0,422,420,1,0,0,
0,422,423,1,0,0,0,423,59,1,0,0,0,424,422,1,0,0,0,425,427,3,24,12,0,426,425,
1,0,0,0,426,427,1,0,0,0,427,428,1,0,0,0,428,429,3,20,10,0,429,61,1,0,0,0,
430,432,3,24,12,0,431,430,1,0,0,0,431,432,1,0,0,0,432,433,1,0,0,0,433,434,
3,20,10,0,434,63,1,0,0,0,435,437,3,80,40,0,436,438,3,66,33,0,437,436,1,0,
0,0,437,438,1,0,0,0,438,65,1,0,0,0,439,441,5,33,0,0,440,442,3,82,41,0,441,
440,1,0,0,0,441,442,1,0,0,0,442,443,1,0,0,0,443,444,5,34,0,0,444,67,1,0,
0,0,445,447,3,76,38,0,446,445,1,0,0,0,446,447,1,0,0,0,447,448,1,0,0,0,448,
449,3,78,39,0,449,450,5,32,0,0,450,69,1,0,0,0,451,452,3,60,30,0,452,453,
5,11,0,0,453,455,1,0,0,0,454,451,1,0,0,0,454,455,1,0,0,0,455,456,1,0,0,0,
456,457,3,62,31,0,457,459,5,7,0,0,458,460,3,72,36,0,459,458,1,0,0,0,459,
460,1,0,0,0,460,467,1,0,0,0,461,462,3,60,30,0,462,464,7,3,0,0,463,465,3,
62,31,0,464,463,1,0,0,0,464,465,1,0,0,0,465,467,1,0,0,0,466,454,1,0,0,0,
466,461,1,0,0,0,467,71,1,0,0,0,468,469,5,72,0,0,469,73,1,0,0,0,470,471,3,
20,10,0,471,75,1,0,0,0,472,473,3,20,10,0,473,77,1,0,0,0,474,487,3,112,56,
0,475,480,7,4,0,0,476,477,5,31,0,0,477,479,7,4,0,0,478,476,1,0,0,0,479,482,
1,0,0,0,480,478,1,0,0,0,480,481,1,0,0,0,481,487,1,0,0,0,482,480,1,0,0,0,
483,487,5,66,0,0,484,487,5,67,0,0,485,487,5,44,0,0,486,474,1,0,0,0,486,475,
1,0,0,0,486,483,1,0,0,0,486,484,1,0,0,0,486,485,1,0,0,0,487,79,1,0,0,0,488,
490,3,24,12,0,489,488,1,0,0,0,489,490,1,0,0,0,490,491,1,0,0,0,491,492,3,
20,10,0,492,81,1,0,0,0,493,498,3,84,42,0,494,495,5,31,0,0,495,497,3,84,42,
0,496,494,1,0,0,0,497,500,1,0,0,0,498,496,1,0,0,0,498,499,1,0,0,0,499,502,
1,0,0,0,500,498,1,0,0,0,501,503,5,31,0,0,502,501,1,0,0,0,502,503,1,0,0,0,
503,83,1,0,0,0,504,508,3,86,43,0,505,508,3,88,44,0,506,508,3,110,55,0,507,
504,1,0,0,0,507,505,1,0,0,0,507,506,1,0,0,0,508,85,1,0,0,0,509,510,7,4,0,
0,510,512,5,32,0,0,511,513,3,110,55,0,512,511,1,0,0,0,512,513,1,0,0,0,513,
87,1,0,0,0,514,515,3,76,38,0,515,516,7,4,0,0,516,89,1,0,0,0,517,521,3,92,
46,0,518,520,3,94,47,0,519,518,1,0,0,0,520,523,1,0,0,0,521,519,1,0,0,0,521,
522,1,0,0,0,522,525,1,0,0,0,523,521,1,0,0,0,524,526,3,96,48,0,525,524,1,
0,0,0,525,526,1,0,0,0,526,91,1,0,0,0,527,528,5,52,0,0,528,529,3,106,53,0,
529,93,1,0,0,0,530,532,5,53,0,0,531,533,3,66,33,0,532,531,1,0,0,0,532,533,
1,0,0,0,533,534,1,0,0,0,534,535,3,106,53,0,535,95,1,0,0,0,536,537,5,54,0,
0,537,538,3,106,53,0,538,97,1,0,0,0,539,543,3,100,50,0,540,542,3,102,51,
0,541,540,1,0,0,0,542,545,1,0,0,0,543,541,1,0,0,0,543,544,1,0,0,0,544,547,
1,0,0,0,545,543,1,0,0,0,546,548,3,104,52,0,547,546,1,0,0,0,547,548,1,0,0,
0,548,99,1,0,0,0,549,550,5,40,0,0,550,552,3,114,57,0,551,553,3,106,53,0,
552,551,1,0,0,0,552,553,1,0,0,0,553,101,1,0,0,0,554,555,5,41,0,0,555,556,
5,40,0,0,556,558,3,114,57,0,557,559,3,106,53,0,558,557,1,0,0,0,558,559,1,
0,0,0,559,103,1,0,0,0,560,562,5,41,0,0,561,563,3,106,53,0,562,561,1,0,0,
0,562,563,1,0,0,0,563,105,1,0,0,0,564,566,5,35,0,0,565,567,3,26,13,0,566,
565,1,0,0,0,566,567,1,0,0,0,567,568,1,0,0,0,568,569,5,36,0,0,569,107,1,0,
0,0,570,572,5,42,0,0,571,573,3,114,57,0,572,571,1,0,0,0,572,573,1,0,0,0,
573,575,1,0,0,0,574,576,3,106,53,0,575,574,1,0,0,0,575,576,1,0,0,0,576,109,
1,0,0,0,577,578,6,55,-1,0,578,598,3,112,56,0,579,580,5,24,0,0,580,598,3,
110,55,13,581,582,5,29,0,0,582,598,3,110,55,12,583,584,3,62,31,0,584,585,
5,59,0,0,585,587,1,0,0,0,586,583,1,0,0,0,586,587,1,0,0,0,587,588,1,0,0,0,
588,598,3,58,29,0,589,598,3,46,23,0,590,591,5,33,0,0,591,592,3,110,55,0,
592,593,5,34,0,0,593,598,1,0,0,0,594,595,3,68,34,0,595,596,3,110,55,1,596,
598,1,0,0,0,597,577,1,0,0,0,597,579,1,0,0,0,597,581,1,0,0,0,597,586,1,0,
0,0,597,589,1,0,0,0,597,590,1,0,0,0,597,594,1,0,0,0,598,622,1,0,0,0,599,
600,10,11,0,0,600,601,7,5,0,0,601,621,3,110,55,12,602,603,10,10,0,0,603,
604,7,6,0,0,604,621,3,110,55,11,605,606,10,9,0,0,606,607,7,7,0,0,607,621,
3,110,55,10,608,609,10,8,0,0,609,610,7,8,0,0,610,621,3,110,55,9,611,612,
10,7,0,0,612,613,5,16,0,0,613,621,3,110,55,8,614,615,10,6,0,0,615,616,5,
15,0,0,616,621,3,110,55,7,617,618,10,5,0,0,618,619,5,23,0,0,619,621,3,110,
55,6,620,599,1,0,0,0,620,602,1,0,0,0,620,605,1,0,0,0,620,608,1,0,0,0,620,
611,1,0,0,0,620,614,1,0,0,0,620,617,1,0,0,0,621,624,1,0,0,0,622,620,1,0,
0,0,622,623,1,0,0,0,623,111,1,0,0,0,624,622,1,0,0,0,625,634,7,9,0,0,626,
634,5,64,0,0,627,634,5,63,0,0,628,634,7,10,0,0,629,634,5,60,0,0,630,634,
5,65,0,0,631,634,7,11,0,0,632,634,5,39,0,0,633,625,1,0,0,0,633,626,1,0,0,
0,633,627,1,0,0,0,633,628,1,0,0,0,633,629,1,0,0,0,633,630,1,0,0,0,633,631,
1,0,0,0,633,632,1,0,0,0,634,113,1,0,0,0,635,637,5,33,0,0,636,638,3,116,58,
0,637,636,1,0,0,0,637,638,1,0,0,0,638,640,1,0,0,0,639,641,5,34,0,0,640,639,
1,0,0,0,640,641,1,0,0,0,641,115,1,0,0,0,642,647,3,112,56,0,643,647,3,110,
55,0,644,647,3,118,59,0,645,647,3,120,60,0,646,642,1,0,0,0,646,643,1,0,0,
0,646,644,1,0,0,0,646,645,1,0,0,0,647,117,1,0,0,0,648,649,7,4,0,0,649,650,
5,55,0,0,650,651,7,4,0,0,651,119,1,0,0,0,652,654,7,12,0,0,653,652,1,0,0,
0,654,655,1,0,0,0,655,653,1,0,0,0,655,656,1,0,0,0,656,121,1,0,0,0,103,123,
127,133,136,141,145,148,152,154,158,160,164,168,174,178,180,185,188,191,
196,199,202,206,209,212,216,225,229,231,236,249,254,258,261,266,270,272,
279,284,286,303,308,312,316,320,324,328,332,337,340,345,350,359,364,369,
372,378,381,384,387,392,397,400,404,407,412,422,426,431,437,441,446,454,
459,464,466,480,486,489,498,502,507,512,521,525,532,543,547,552,558,562,
566,572,575,586,597,620,622,633,637,640,646,655];


const atn = new antlr4.atn.ATNDeserializer().deserialize(serializedATN);

const decisionsToDFA = atn.decisionToState.map( (ds, index) => new antlr4.dfa.DFA(ds, index) );

const sharedContextCache = new antlr4.PredictionContextCache();

export default class sequenceParser extends antlr4.Parser {

    static grammarFileName = "java-escape";
    static literalNames = [ null, null, "'const'", "'readonly'", "'static'", 
                            "'await'", null, "':'", "'<<'", "'>>'", "'-->'", 
                            "'->'", null, "'['", "']'", "'||'", "'&&'", 
                            "'=='", "'!='", "'>'", "'<'", "'>='", "'<='", 
                            "'+'", "'-'", "'*'", "'/'", "'%'", "'^'", "'!'", 
                            "';'", "','", "'='", "'('", "')'", "'{'", "'}'", 
                            "'true'", "'false'", null, "'if'", "'else'", 
                            null, "'return'", "'new'", "'par'", "'group'", 
                            "'opt'", "'critical'", null, "'ref'", "'as'", 
                            "'try'", "'catch'", "'finally'", "'in'", null, 
                            null, null, "'.'" ];
    static symbolicNames = [ null, "WS", "CONSTANT", "READONLY", "STATIC", 
                             "AWAIT", "TITLE", "COL", "SOPEN", "SCLOSE", 
                             "RETURN_ARROW", "ARROW", "COLOR", "LBRACKET", 
                             "RBRACKET", "OR", "AND", "EQ", "NEQ", "GT", 
                             "LT", "GTEQ", "LTEQ", "PLUS", "MINUS", "MULT", 
                             "DIV", "MOD", "POW", "NOT", "SCOL", "COMMA", 
                             "ASSIGN", "OPAR", "CPAR", "OBRACE", "CBRACE", 
                             "TRUE", "FALSE", "NIL", "IF", "ELSE", "WHILE", 
                             "RETURN", "NEW", "PAR", "GROUP", "OPT", "CRITICAL", 
                             "SECTION", "REF", "AS", "TRY", "CATCH", "FINALLY", 
                             "IN", "STARTER_LXR", "ANNOTATION_RET", "ANNOTATION", 
                             "DOT", "ID", "INT", "FLOAT", "MONEY", "NUMBER_UNIT", 
                             "DIGIT_LEADING_NAME", "CSTRING", "USTRING", 
                             "CR", "COMMENT", "OTHER", "DIVIDER", "EVENT_PAYLOAD_LXR", 
                             "EVENT_END", "TITLE_CONTENT", "TITLE_END", 
                             "EMOJI_SHORTCODE" ];
    static ruleNames = [ "prog", "title", "head", "group", "starterExp", 
                         "starter", "participant", "stereotype", "label", 
                         "participantType", "name", "width", "emoji", "block", 
                         "ret", "returnAsyncMessage", "divider", "dividerNote", 
                         "stat", "par", "opt", "critical", "section", "creation", 
                         "ref", "creationBody", "message", "messageBody", 
                         "fromTo", "func", "from", "to", "signature", "invocation", 
                         "assignment", "asyncMessage", "content", "construct", 
                         "type", "assignee", "methodName", "parameters", 
                         "parameter", "namedParameter", "declaration", "tcf", 
                         "tryBlock", "catchBlock", "finallyBlock", "alt", 
                         "ifBlock", "elseIfBlock", "elseBlock", "braceBlock", 
                         "loop", "expr", "atom", "parExpr", "condition", 
                         "inExpr", "textExpr" ];

    constructor(input) {
        super(input);
        this._interp = new antlr4.atn.ParserATNSimulator(this, atn, decisionsToDFA, sharedContextCache);
        this.ruleNames = sequenceParser.ruleNames;
        this.literalNames = sequenceParser.literalNames;
        this.symbolicNames = sequenceParser.symbolicNames;
    }

    get atn() {
        return atn;
    }

    sempred(localctx, ruleIndex, predIndex) {
    	switch(ruleIndex) {
    	case 55:
    	    		return this.expr_sempred(localctx, predIndex);
        default:
            throw "No predicate with index:" + ruleIndex;
       }
    }

    expr_sempred(localctx, predIndex) {
    	switch(predIndex) {
    		case 0:
    			return this.precpred(this._ctx, 11);
    		case 1:
    			return this.precpred(this._ctx, 10);
    		case 2:
    			return this.precpred(this._ctx, 9);
    		case 3:
    			return this.precpred(this._ctx, 8);
    		case 4:
    			return this.precpred(this._ctx, 7);
    		case 5:
    			return this.precpred(this._ctx, 6);
    		case 6:
    			return this.precpred(this._ctx, 5);
    		default:
    			throw "No predicate with index:" + predIndex;
    	}
    };




	prog() {
	    let localctx = new ProgContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 0, sequenceParser.RULE_prog);
	    var _la = 0; // Token type
	    try {
	        this.state = 141;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,4,this._ctx);
	        switch(la_) {
	        case 1:
	            this.enterOuterAlt(localctx, 1);
	            this.state = 123;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            if(_la===6) {
	                this.state = 122;
	                this.title();
	            }

	            this.state = 125;
	            this.match(sequenceParser.EOF);
	            break;

	        case 2:
	            this.enterOuterAlt(localctx, 2);
	            this.state = 127;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            if(_la===6) {
	                this.state = 126;
	                this.title();
	            }

	            this.state = 129;
	            this.head();
	            this.state = 130;
	            this.match(sequenceParser.EOF);
	            break;

	        case 3:
	            this.enterOuterAlt(localctx, 3);
	            this.state = 133;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            if(_la===6) {
	                this.state = 132;
	                this.title();
	            }

	            this.state = 136;
	            this._errHandler.sync(this);
	            var la_ = this._interp.adaptivePredict(this._input,3,this._ctx);
	            if(la_===1) {
	                this.state = 135;
	                this.head();

	            }
	            this.state = 138;
	            this.block();
	            this.state = 139;
	            this.match(sequenceParser.EOF);
	            break;

	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	title() {
	    let localctx = new TitleContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 2, sequenceParser.RULE_title);
	    var _la = 0; // Token type
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 143;
	        this.match(sequenceParser.TITLE);
	        this.state = 145;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===74) {
	            this.state = 144;
	            this.match(sequenceParser.TITLE_CONTENT);
	        }

	        this.state = 148;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===75) {
	            this.state = 147;
	            this.match(sequenceParser.TITLE_END);
	        }

	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	head() {
	    let localctx = new HeadContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 4, sequenceParser.RULE_head);
	    try {
	        this.state = 164;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,11,this._ctx);
	        switch(la_) {
	        case 1:
	            this.enterOuterAlt(localctx, 1);
	            this.state = 152; 
	            this._errHandler.sync(this);
	            var _alt = 1;
	            do {
	            	switch (_alt) {
	            	case 1:
	            		this.state = 152;
	            		this._errHandler.sync(this);
	            		switch(this._input.LA(1)) {
	            		case 46:
	            		    this.state = 150;
	            		    this.group();
	            		    break;
	            		case 8:
	            		case 13:
	            		case 20:
	            		case 58:
	            		case 60:
	            		case 65:
	            		case 66:
	            		case 67:
	            		case 76:
	            		    this.state = 151;
	            		    this.participant();
	            		    break;
	            		default:
	            		    throw new antlr4.error.NoViableAltException(this);
	            		}
	            		break;
	            	default:
	            		throw new antlr4.error.NoViableAltException(this);
	            	}
	            	this.state = 154; 
	            	this._errHandler.sync(this);
	            	_alt = this._interp.adaptivePredict(this._input,8, this._ctx);
	            } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
	            break;

	        case 2:
	            this.enterOuterAlt(localctx, 2);
	            this.state = 160;
	            this._errHandler.sync(this);
	            var _alt = this._interp.adaptivePredict(this._input,10,this._ctx)
	            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
	                if(_alt===1) {
	                    this.state = 158;
	                    this._errHandler.sync(this);
	                    switch(this._input.LA(1)) {
	                    case 46:
	                        this.state = 156;
	                        this.group();
	                        break;
	                    case 8:
	                    case 13:
	                    case 20:
	                    case 58:
	                    case 60:
	                    case 65:
	                    case 66:
	                    case 67:
	                    case 76:
	                        this.state = 157;
	                        this.participant();
	                        break;
	                    default:
	                        throw new antlr4.error.NoViableAltException(this);
	                    } 
	                }
	                this.state = 162;
	                this._errHandler.sync(this);
	                _alt = this._interp.adaptivePredict(this._input,10,this._ctx);
	            }

	            this.state = 163;
	            this.starterExp();
	            break;

	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	group() {
	    let localctx = new GroupContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 6, sequenceParser.RULE_group);
	    var _la = 0; // Token type
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 166;
	        this.match(sequenceParser.GROUP);
	        this.state = 168;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,12,this._ctx);
	        if(la_===1) {
	            this.state = 167;
	            this.name();

	        }
	        this.state = 180;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,15,this._ctx);
	        if(la_===1) {
	            this.state = 170;
	            this.match(sequenceParser.OBRACE);
	            this.state = 174;
	            this._errHandler.sync(this);
	            var _alt = this._interp.adaptivePredict(this._input,13,this._ctx)
	            while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
	                if(_alt===1) {
	                    this.state = 171;
	                    this.participant(); 
	                }
	                this.state = 176;
	                this._errHandler.sync(this);
	                _alt = this._interp.adaptivePredict(this._input,13,this._ctx);
	            }

	            this.state = 178;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            if(_la===36) {
	                this.state = 177;
	                this.match(sequenceParser.CBRACE);
	            }


	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	starterExp() {
	    let localctx = new StarterExpContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 8, sequenceParser.RULE_starterExp);
	    var _la = 0; // Token type
	    try {
	        this.state = 191;
	        this._errHandler.sync(this);
	        switch(this._input.LA(1)) {
	        case 56:
	            this.enterOuterAlt(localctx, 1);
	            this.state = 182;
	            this.match(sequenceParser.STARTER_LXR);
	            this.state = 188;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            if(_la===33) {
	                this.state = 183;
	                this.match(sequenceParser.OPAR);
	                this.state = 185;
	                this._errHandler.sync(this);
	                _la = this._input.LA(1);
	                if(((((_la - 60)) & ~0x1f) == 0 && ((1 << (_la - 60)) & 225) !== 0)) {
	                    this.state = 184;
	                    this.starter();
	                }

	                this.state = 187;
	                this.match(sequenceParser.CPAR);
	            }

	            break;
	        case 58:
	            this.enterOuterAlt(localctx, 2);
	            this.state = 190;
	            this.match(sequenceParser.ANNOTATION);
	            break;
	        default:
	            throw new antlr4.error.NoViableAltException(this);
	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	starter() {
	    let localctx = new StarterContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 10, sequenceParser.RULE_starter);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 193;
	        this.name();
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	participant() {
	    let localctx = new ParticipantContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 12, sequenceParser.RULE_participant);
	    var _la = 0; // Token type
	    try {
	        this.state = 216;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,25,this._ctx);
	        switch(la_) {
	        case 1:
	            this.enterOuterAlt(localctx, 1);
	            this.state = 196;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            if(_la===58) {
	                this.state = 195;
	                this.participantType();
	            }

	            this.state = 199;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            if(_la===8 || _la===20) {
	                this.state = 198;
	                this.stereotype();
	            }

	            this.state = 202;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            if(_la===13 || _la===76) {
	                this.state = 201;
	                this.emoji();
	            }

	            this.state = 204;
	            this.name();
	            this.state = 206;
	            this._errHandler.sync(this);
	            var la_ = this._interp.adaptivePredict(this._input,22,this._ctx);
	            if(la_===1) {
	                this.state = 205;
	                this.width();

	            }
	            this.state = 209;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            if(_la===51) {
	                this.state = 208;
	                this.label();
	            }

	            this.state = 212;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            if(_la===12) {
	                this.state = 211;
	                this.match(sequenceParser.COLOR);
	            }

	            break;

	        case 2:
	            this.enterOuterAlt(localctx, 2);
	            this.state = 214;
	            this.stereotype();
	            break;

	        case 3:
	            this.enterOuterAlt(localctx, 3);
	            this.state = 215;
	            this.participantType();
	            break;

	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	stereotype() {
	    let localctx = new StereotypeContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 14, sequenceParser.RULE_stereotype);
	    var _la = 0; // Token type
	    try {
	        this.state = 231;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,28,this._ctx);
	        switch(la_) {
	        case 1:
	            this.enterOuterAlt(localctx, 1);
	            this.state = 218;
	            this.match(sequenceParser.SOPEN);
	            this.state = 219;
	            this.name();
	            this.state = 220;
	            this.match(sequenceParser.SCLOSE);
	            break;

	        case 2:
	            this.enterOuterAlt(localctx, 2);
	            this.state = 222;
	            this.match(sequenceParser.SOPEN);
	            this.state = 223;
	            this.name();
	            this.state = 225;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            if(_la===19) {
	                this.state = 224;
	                this.match(sequenceParser.GT);
	            }

	            break;

	        case 3:
	            this.enterOuterAlt(localctx, 3);
	            this.state = 227;
	            _la = this._input.LA(1);
	            if(!(_la===8 || _la===20)) {
	            this._errHandler.recoverInline(this);
	            }
	            else {
	            	this._errHandler.reportMatch(this);
	                this.consume();
	            }
	            this.state = 229;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            if(_la===9 || _la===19) {
	                this.state = 228;
	                _la = this._input.LA(1);
	                if(!(_la===9 || _la===19)) {
	                this._errHandler.recoverInline(this);
	                }
	                else {
	                	this._errHandler.reportMatch(this);
	                    this.consume();
	                }
	            }

	            break;

	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	label() {
	    let localctx = new LabelContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 16, sequenceParser.RULE_label);
	    try {
	        this.state = 236;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,29,this._ctx);
	        switch(la_) {
	        case 1:
	            this.enterOuterAlt(localctx, 1);
	            this.state = 233;
	            this.match(sequenceParser.AS);
	            this.state = 234;
	            this.name();
	            break;

	        case 2:
	            this.enterOuterAlt(localctx, 2);
	            this.state = 235;
	            this.match(sequenceParser.AS);
	            break;

	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	participantType() {
	    let localctx = new ParticipantTypeContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 18, sequenceParser.RULE_participantType);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 238;
	        this.match(sequenceParser.ANNOTATION);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	name() {
	    let localctx = new NameContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 20, sequenceParser.RULE_name);
	    var _la = 0; // Token type
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 240;
	        _la = this._input.LA(1);
	        if(!(((((_la - 60)) & ~0x1f) == 0 && ((1 << (_la - 60)) & 225) !== 0))) {
	        this._errHandler.recoverInline(this);
	        }
	        else {
	        	this._errHandler.reportMatch(this);
	            this.consume();
	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	width() {
	    let localctx = new WidthContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 22, sequenceParser.RULE_width);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 242;
	        this.match(sequenceParser.INT);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	emoji() {
	    let localctx = new EmojiContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 24, sequenceParser.RULE_emoji);
	    try {
	        this.state = 249;
	        this._errHandler.sync(this);
	        switch(this._input.LA(1)) {
	        case 13:
	            this.enterOuterAlt(localctx, 1);
	            this.state = 244;
	            this.match(sequenceParser.LBRACKET);
	            this.state = 245;
	            this.name();
	            this.state = 246;
	            this.match(sequenceParser.RBRACKET);
	            break;
	        case 76:
	            this.enterOuterAlt(localctx, 2);
	            this.state = 248;
	            this.match(sequenceParser.EMOJI_SHORTCODE);
	            break;
	        default:
	            throw new antlr4.error.NoViableAltException(this);
	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	block() {
	    let localctx = new BlockContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 26, sequenceParser.RULE_block);
	    var _la = 0; // Token type
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 252; 
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        do {
	            this.state = 251;
	            this.stat();
	            this.state = 254; 
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	        } while(((((_la - 13)) & ~0x1f) == 0 && ((1 << (_la - 13)) & 4013948929) !== 0) || ((((_la - 45)) & ~0x1f) == 0 && ((1 << (_la - 45)) & 2222952637) !== 0));
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	ret() {
	    let localctx = new RetContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 28, sequenceParser.RULE_ret);
	    var _la = 0; // Token type
	    try {
	        this.state = 272;
	        this._errHandler.sync(this);
	        switch(this._input.LA(1)) {
	        case 43:
	            this.enterOuterAlt(localctx, 1);
	            this.state = 256;
	            this.match(sequenceParser.RETURN);
	            this.state = 258;
	            this._errHandler.sync(this);
	            var la_ = this._interp.adaptivePredict(this._input,32,this._ctx);
	            if(la_===1) {
	                this.state = 257;
	                this.expr(0);

	            }
	            this.state = 261;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            if(_la===30) {
	                this.state = 260;
	                this.match(sequenceParser.SCOL);
	            }

	            break;
	        case 57:
	            this.enterOuterAlt(localctx, 2);
	            this.state = 263;
	            this.match(sequenceParser.ANNOTATION_RET);
	            this.state = 264;
	            this.asyncMessage();
	            this.state = 266;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            if(_la===73) {
	                this.state = 265;
	                this.match(sequenceParser.EVENT_END);
	            }

	            break;
	        case 13:
	        case 60:
	        case 65:
	        case 66:
	        case 67:
	        case 76:
	            this.enterOuterAlt(localctx, 3);
	            this.state = 268;
	            this.returnAsyncMessage();
	            this.state = 270;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            if(_la===73) {
	                this.state = 269;
	                this.match(sequenceParser.EVENT_END);
	            }

	            break;
	        default:
	            throw new antlr4.error.NoViableAltException(this);
	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	returnAsyncMessage() {
	    let localctx = new ReturnAsyncMessageContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 30, sequenceParser.RULE_returnAsyncMessage);
	    var _la = 0; // Token type
	    try {
	        this.state = 286;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,39,this._ctx);
	        switch(la_) {
	        case 1:
	            this.enterOuterAlt(localctx, 1);
	            this.state = 274;
	            this.from();
	            this.state = 275;
	            this.match(sequenceParser.RETURN_ARROW);
	            this.state = 276;
	            this.to();
	            this.state = 277;
	            this.match(sequenceParser.COL);
	            this.state = 279;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            if(_la===72) {
	                this.state = 278;
	                this.content();
	            }

	            break;

	        case 2:
	            this.enterOuterAlt(localctx, 2);
	            this.state = 281;
	            this.from();
	            this.state = 282;
	            this.match(sequenceParser.RETURN_ARROW);
	            this.state = 284;
	            this._errHandler.sync(this);
	            var la_ = this._interp.adaptivePredict(this._input,38,this._ctx);
	            if(la_===1) {
	                this.state = 283;
	                this.to();

	            }
	            break;

	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	divider() {
	    let localctx = new DividerContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 32, sequenceParser.RULE_divider);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 288;
	        this.dividerNote();
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	dividerNote() {
	    let localctx = new DividerNoteContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 34, sequenceParser.RULE_dividerNote);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 290;
	        this.match(sequenceParser.DIVIDER);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	stat() {
	    let localctx = new StatContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 36, sequenceParser.RULE_stat);
	    var _la = 0; // Token type
	    try {
	        this.state = 308;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,41,this._ctx);
	        switch(la_) {
	        case 1:
	            this.enterOuterAlt(localctx, 1);
	            this.state = 292;
	            this.alt();
	            break;

	        case 2:
	            this.enterOuterAlt(localctx, 2);
	            this.state = 293;
	            this.par();
	            break;

	        case 3:
	            this.enterOuterAlt(localctx, 3);
	            this.state = 294;
	            this.opt();
	            break;

	        case 4:
	            this.enterOuterAlt(localctx, 4);
	            this.state = 295;
	            this.critical();
	            break;

	        case 5:
	            this.enterOuterAlt(localctx, 5);
	            this.state = 296;
	            this.section();
	            break;

	        case 6:
	            this.enterOuterAlt(localctx, 6);
	            this.state = 297;
	            this.ref();
	            break;

	        case 7:
	            this.enterOuterAlt(localctx, 7);
	            this.state = 298;
	            this.loop();
	            break;

	        case 8:
	            this.enterOuterAlt(localctx, 8);
	            this.state = 299;
	            this.creation();
	            break;

	        case 9:
	            this.enterOuterAlt(localctx, 9);
	            this.state = 300;
	            this.message();
	            break;

	        case 10:
	            this.enterOuterAlt(localctx, 10);
	            this.state = 301;
	            this.asyncMessage();
	            this.state = 303;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            if(_la===73) {
	                this.state = 302;
	                this.match(sequenceParser.EVENT_END);
	            }

	            break;

	        case 11:
	            this.enterOuterAlt(localctx, 11);
	            this.state = 305;
	            this.ret();
	            break;

	        case 12:
	            this.enterOuterAlt(localctx, 12);
	            this.state = 306;
	            this.divider();
	            break;

	        case 13:
	            this.enterOuterAlt(localctx, 13);
	            this.state = 307;
	            this.tcf();
	            break;

	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	par() {
	    let localctx = new ParContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 38, sequenceParser.RULE_par);
	    var _la = 0; // Token type
	    try {
	        this.state = 316;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,43,this._ctx);
	        switch(la_) {
	        case 1:
	            this.enterOuterAlt(localctx, 1);
	            this.state = 310;
	            this.match(sequenceParser.PAR);
	            this.state = 312;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            if(_la===33) {
	                this.state = 311;
	                this.parExpr();
	            }

	            this.state = 314;
	            this.braceBlock();
	            break;

	        case 2:
	            this.enterOuterAlt(localctx, 2);
	            this.state = 315;
	            this.match(sequenceParser.PAR);
	            break;

	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	opt() {
	    let localctx = new OptContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 40, sequenceParser.RULE_opt);
	    var _la = 0; // Token type
	    try {
	        this.state = 324;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,45,this._ctx);
	        switch(la_) {
	        case 1:
	            this.enterOuterAlt(localctx, 1);
	            this.state = 318;
	            this.match(sequenceParser.OPT);
	            this.state = 320;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            if(_la===33) {
	                this.state = 319;
	                this.parExpr();
	            }

	            this.state = 322;
	            this.braceBlock();
	            break;

	        case 2:
	            this.enterOuterAlt(localctx, 2);
	            this.state = 323;
	            this.match(sequenceParser.OPT);
	            break;

	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	critical() {
	    let localctx = new CriticalContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 42, sequenceParser.RULE_critical);
	    var _la = 0; // Token type
	    try {
	        this.state = 332;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,47,this._ctx);
	        switch(la_) {
	        case 1:
	            this.enterOuterAlt(localctx, 1);
	            this.state = 326;
	            this.match(sequenceParser.CRITICAL);
	            this.state = 328;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            if(_la===33) {
	                this.state = 327;
	                this.parExpr();
	            }

	            this.state = 330;
	            this.braceBlock();
	            break;

	        case 2:
	            this.enterOuterAlt(localctx, 2);
	            this.state = 331;
	            this.match(sequenceParser.CRITICAL);
	            break;

	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	section() {
	    let localctx = new SectionContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 44, sequenceParser.RULE_section);
	    var _la = 0; // Token type
	    try {
	        this.state = 345;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,50,this._ctx);
	        switch(la_) {
	        case 1:
	            this.enterOuterAlt(localctx, 1);
	            this.state = 334;
	            this.match(sequenceParser.SECTION);
	            this.state = 340;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            if(_la===33) {
	                this.state = 335;
	                this.match(sequenceParser.OPAR);
	                this.state = 337;
	                this._errHandler.sync(this);
	                _la = this._input.LA(1);
	                if(((((_la - 37)) & ~0x1f) == 0 && ((1 << (_la - 37)) & 2139095047) !== 0)) {
	                    this.state = 336;
	                    this.atom();
	                }

	                this.state = 339;
	                this.match(sequenceParser.CPAR);
	            }

	            this.state = 342;
	            this.braceBlock();
	            break;

	        case 2:
	            this.enterOuterAlt(localctx, 2);
	            this.state = 343;
	            this.braceBlock();
	            break;

	        case 3:
	            this.enterOuterAlt(localctx, 3);
	            this.state = 344;
	            this.match(sequenceParser.SECTION);
	            break;

	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	creation() {
	    let localctx = new CreationContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 46, sequenceParser.RULE_creation);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 347;
	        this.creationBody();
	        this.state = 350;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,51,this._ctx);
	        if(la_===1) {
	            this.state = 348;
	            this.match(sequenceParser.SCOL);

	        } else if(la_===2) {
	            this.state = 349;
	            this.braceBlock();

	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	ref() {
	    let localctx = new RefContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 48, sequenceParser.RULE_ref);
	    var _la = 0; // Token type
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 352;
	        this.match(sequenceParser.REF);
	        this.state = 353;
	        this.match(sequenceParser.OPAR);

	        this.state = 354;
	        this.name();
	        this.state = 364;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        while(_la===31) {
	            this.state = 355;
	            this.match(sequenceParser.COMMA);
	            this.state = 359;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            while(((((_la - 60)) & ~0x1f) == 0 && ((1 << (_la - 60)) & 225) !== 0)) {
	                this.state = 356;
	                this.name();
	                this.state = 361;
	                this._errHandler.sync(this);
	                _la = this._input.LA(1);
	            }
	            this.state = 366;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	        }
	        this.state = 367;
	        this.match(sequenceParser.CPAR);
	        this.state = 369;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===30) {
	            this.state = 368;
	            this.match(sequenceParser.SCOL);
	        }

	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	creationBody() {
	    let localctx = new CreationBodyContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 50, sequenceParser.RULE_creationBody);
	    var _la = 0; // Token type
	    try {
	        this.state = 387;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,59,this._ctx);
	        switch(la_) {
	        case 1:
	            this.enterOuterAlt(localctx, 1);
	            this.state = 372;
	            this._errHandler.sync(this);
	            var la_ = this._interp.adaptivePredict(this._input,55,this._ctx);
	            if(la_===1) {
	                this.state = 371;
	                this.assignment();

	            }
	            this.state = 374;
	            this.match(sequenceParser.NEW);
	            this.state = 375;
	            this.construct();
	            this.state = 381;
	            this._errHandler.sync(this);
	            var la_ = this._interp.adaptivePredict(this._input,57,this._ctx);
	            if(la_===1) {
	                this.state = 376;
	                this.match(sequenceParser.OPAR);
	                this.state = 378;
	                this._errHandler.sync(this);
	                _la = this._input.LA(1);
	                if(((((_la - 13)) & ~0x1f) == 0 && ((1 << (_la - 13)) & 2266040321) !== 0) || ((((_la - 60)) & ~0x1f) == 0 && ((1 << (_la - 60)) & 65791) !== 0)) {
	                    this.state = 377;
	                    this.parameters();
	                }

	                this.state = 380;
	                this.match(sequenceParser.CPAR);

	            }
	            break;

	        case 2:
	            this.enterOuterAlt(localctx, 2);
	            this.state = 384;
	            this._errHandler.sync(this);
	            var la_ = this._interp.adaptivePredict(this._input,58,this._ctx);
	            if(la_===1) {
	                this.state = 383;
	                this.assignment();

	            }
	            this.state = 386;
	            this.match(sequenceParser.NEW);
	            break;

	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	message() {
	    let localctx = new MessageContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 52, sequenceParser.RULE_message);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 389;
	        this.messageBody();
	        this.state = 392;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,60,this._ctx);
	        if(la_===1) {
	            this.state = 390;
	            this.match(sequenceParser.SCOL);

	        } else if(la_===2) {
	            this.state = 391;
	            this.braceBlock();

	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	messageBody() {
	    let localctx = new MessageBodyContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 54, sequenceParser.RULE_messageBody);
	    try {
	        this.state = 407;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,64,this._ctx);
	        switch(la_) {
	        case 1:
	            this.enterOuterAlt(localctx, 1);
	            this.state = 394;
	            this.assignment();
	            this.state = 400;
	            this._errHandler.sync(this);
	            var la_ = this._interp.adaptivePredict(this._input,62,this._ctx);
	            if(la_===1) {
	                this.state = 395;
	                this.fromTo();
	                this.state = 397;
	                this._errHandler.sync(this);
	                var la_ = this._interp.adaptivePredict(this._input,61,this._ctx);
	                if(la_===1) {
	                    this.state = 396;
	                    this.func();

	                }

	            } else if(la_===2) {
	                this.state = 399;
	                this.func();

	            }
	            break;

	        case 2:
	            this.enterOuterAlt(localctx, 2);
	            this.state = 402;
	            this.fromTo();
	            this.state = 404;
	            this._errHandler.sync(this);
	            var la_ = this._interp.adaptivePredict(this._input,63,this._ctx);
	            if(la_===1) {
	                this.state = 403;
	                this.func();

	            }
	            break;

	        case 3:
	            this.enterOuterAlt(localctx, 3);
	            this.state = 406;
	            this.func();
	            break;

	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	fromTo() {
	    let localctx = new FromToContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 56, sequenceParser.RULE_fromTo);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 412;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,65,this._ctx);
	        if(la_===1) {
	            this.state = 409;
	            this.from();
	            this.state = 410;
	            this.match(sequenceParser.ARROW);

	        }
	        this.state = 414;
	        this.to();
	        this.state = 415;
	        this.match(sequenceParser.DOT);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	func() {
	    let localctx = new FuncContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 58, sequenceParser.RULE_func);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 417;
	        this.signature();
	        this.state = 422;
	        this._errHandler.sync(this);
	        var _alt = this._interp.adaptivePredict(this._input,66,this._ctx)
	        while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
	            if(_alt===1) {
	                this.state = 418;
	                this.match(sequenceParser.DOT);
	                this.state = 419;
	                this.signature(); 
	            }
	            this.state = 424;
	            this._errHandler.sync(this);
	            _alt = this._interp.adaptivePredict(this._input,66,this._ctx);
	        }

	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	from() {
	    let localctx = new FromContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 60, sequenceParser.RULE_from);
	    var _la = 0; // Token type
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 426;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===13 || _la===76) {
	            this.state = 425;
	            this.emoji();
	        }

	        this.state = 428;
	        this.name();
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	to() {
	    let localctx = new ToContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 62, sequenceParser.RULE_to);
	    var _la = 0; // Token type
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 431;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===13 || _la===76) {
	            this.state = 430;
	            this.emoji();
	        }

	        this.state = 433;
	        this.name();
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	signature() {
	    let localctx = new SignatureContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 64, sequenceParser.RULE_signature);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 435;
	        this.methodName();
	        this.state = 437;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,69,this._ctx);
	        if(la_===1) {
	            this.state = 436;
	            this.invocation();

	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	invocation() {
	    let localctx = new InvocationContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 66, sequenceParser.RULE_invocation);
	    var _la = 0; // Token type
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 439;
	        this.match(sequenceParser.OPAR);
	        this.state = 441;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(((((_la - 13)) & ~0x1f) == 0 && ((1 << (_la - 13)) & 2266040321) !== 0) || ((((_la - 60)) & ~0x1f) == 0 && ((1 << (_la - 60)) & 65791) !== 0)) {
	            this.state = 440;
	            this.parameters();
	        }

	        this.state = 443;
	        this.match(sequenceParser.CPAR);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	assignment() {
	    let localctx = new AssignmentContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 68, sequenceParser.RULE_assignment);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 446;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,71,this._ctx);
	        if(la_===1) {
	            this.state = 445;
	            this.type();

	        }
	        this.state = 448;
	        this.assignee();
	        this.state = 449;
	        this.match(sequenceParser.ASSIGN);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	asyncMessage() {
	    let localctx = new AsyncMessageContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 70, sequenceParser.RULE_asyncMessage);
	    var _la = 0; // Token type
	    try {
	        this.state = 466;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,75,this._ctx);
	        switch(la_) {
	        case 1:
	            this.enterOuterAlt(localctx, 1);
	            this.state = 454;
	            this._errHandler.sync(this);
	            var la_ = this._interp.adaptivePredict(this._input,72,this._ctx);
	            if(la_===1) {
	                this.state = 451;
	                this.from();
	                this.state = 452;
	                this.match(sequenceParser.ARROW);

	            }
	            this.state = 456;
	            this.to();
	            this.state = 457;
	            this.match(sequenceParser.COL);
	            this.state = 459;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            if(_la===72) {
	                this.state = 458;
	                this.content();
	            }

	            break;

	        case 2:
	            this.enterOuterAlt(localctx, 2);
	            this.state = 461;
	            this.from();
	            this.state = 462;
	            _la = this._input.LA(1);
	            if(!(_la===11 || _la===24)) {
	            this._errHandler.recoverInline(this);
	            }
	            else {
	            	this._errHandler.reportMatch(this);
	                this.consume();
	            }
	            this.state = 464;
	            this._errHandler.sync(this);
	            var la_ = this._interp.adaptivePredict(this._input,74,this._ctx);
	            if(la_===1) {
	                this.state = 463;
	                this.to();

	            }
	            break;

	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	content() {
	    let localctx = new ContentContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 72, sequenceParser.RULE_content);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 468;
	        this.match(sequenceParser.EVENT_PAYLOAD_LXR);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	construct() {
	    let localctx = new ConstructContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 74, sequenceParser.RULE_construct);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 470;
	        this.name();
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	type() {
	    let localctx = new TypeContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 76, sequenceParser.RULE_type);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 472;
	        this.name();
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	assignee() {
	    let localctx = new AssigneeContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 78, sequenceParser.RULE_assignee);
	    var _la = 0; // Token type
	    try {
	        this.state = 486;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,77,this._ctx);
	        switch(la_) {
	        case 1:
	            this.enterOuterAlt(localctx, 1);
	            this.state = 474;
	            this.atom();
	            break;

	        case 2:
	            this.enterOuterAlt(localctx, 2);
	            this.state = 475;
	            _la = this._input.LA(1);
	            if(!(_la===60 || _la===65)) {
	            this._errHandler.recoverInline(this);
	            }
	            else {
	            	this._errHandler.reportMatch(this);
	                this.consume();
	            }
	            this.state = 480;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	            while(_la===31) {
	                this.state = 476;
	                this.match(sequenceParser.COMMA);
	                this.state = 477;
	                _la = this._input.LA(1);
	                if(!(_la===60 || _la===65)) {
	                this._errHandler.recoverInline(this);
	                }
	                else {
	                	this._errHandler.reportMatch(this);
	                    this.consume();
	                }
	                this.state = 482;
	                this._errHandler.sync(this);
	                _la = this._input.LA(1);
	            }
	            break;

	        case 3:
	            this.enterOuterAlt(localctx, 3);
	            this.state = 483;
	            this.match(sequenceParser.CSTRING);
	            break;

	        case 4:
	            this.enterOuterAlt(localctx, 4);
	            this.state = 484;
	            this.match(sequenceParser.USTRING);
	            break;

	        case 5:
	            this.enterOuterAlt(localctx, 5);
	            this.state = 485;
	            this.match(sequenceParser.NEW);
	            break;

	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	methodName() {
	    let localctx = new MethodNameContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 80, sequenceParser.RULE_methodName);
	    var _la = 0; // Token type
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 489;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===13 || _la===76) {
	            this.state = 488;
	            this.emoji();
	        }

	        this.state = 491;
	        this.name();
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	parameters() {
	    let localctx = new ParametersContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 82, sequenceParser.RULE_parameters);
	    var _la = 0; // Token type
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 493;
	        this.parameter();
	        this.state = 498;
	        this._errHandler.sync(this);
	        var _alt = this._interp.adaptivePredict(this._input,79,this._ctx)
	        while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
	            if(_alt===1) {
	                this.state = 494;
	                this.match(sequenceParser.COMMA);
	                this.state = 495;
	                this.parameter(); 
	            }
	            this.state = 500;
	            this._errHandler.sync(this);
	            _alt = this._interp.adaptivePredict(this._input,79,this._ctx);
	        }

	        this.state = 502;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===31) {
	            this.state = 501;
	            this.match(sequenceParser.COMMA);
	        }

	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	parameter() {
	    let localctx = new ParameterContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 84, sequenceParser.RULE_parameter);
	    try {
	        this.state = 507;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,81,this._ctx);
	        switch(la_) {
	        case 1:
	            this.enterOuterAlt(localctx, 1);
	            this.state = 504;
	            this.namedParameter();
	            break;

	        case 2:
	            this.enterOuterAlt(localctx, 2);
	            this.state = 505;
	            this.declaration();
	            break;

	        case 3:
	            this.enterOuterAlt(localctx, 3);
	            this.state = 506;
	            this.expr(0);
	            break;

	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	namedParameter() {
	    let localctx = new NamedParameterContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 86, sequenceParser.RULE_namedParameter);
	    var _la = 0; // Token type
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 509;
	        _la = this._input.LA(1);
	        if(!(_la===60 || _la===65)) {
	        this._errHandler.recoverInline(this);
	        }
	        else {
	        	this._errHandler.reportMatch(this);
	            this.consume();
	        }
	        this.state = 510;
	        this.match(sequenceParser.ASSIGN);
	        this.state = 512;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(((((_la - 13)) & ~0x1f) == 0 && ((1 << (_la - 13)) & 2266040321) !== 0) || ((((_la - 60)) & ~0x1f) == 0 && ((1 << (_la - 60)) & 65791) !== 0)) {
	            this.state = 511;
	            this.expr(0);
	        }

	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	declaration() {
	    let localctx = new DeclarationContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 88, sequenceParser.RULE_declaration);
	    var _la = 0; // Token type
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 514;
	        this.type();
	        this.state = 515;
	        _la = this._input.LA(1);
	        if(!(_la===60 || _la===65)) {
	        this._errHandler.recoverInline(this);
	        }
	        else {
	        	this._errHandler.reportMatch(this);
	            this.consume();
	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	tcf() {
	    let localctx = new TcfContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 90, sequenceParser.RULE_tcf);
	    var _la = 0; // Token type
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 517;
	        this.tryBlock();
	        this.state = 521;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        while(_la===53) {
	            this.state = 518;
	            this.catchBlock();
	            this.state = 523;
	            this._errHandler.sync(this);
	            _la = this._input.LA(1);
	        }
	        this.state = 525;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===54) {
	            this.state = 524;
	            this.finallyBlock();
	        }

	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	tryBlock() {
	    let localctx = new TryBlockContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 92, sequenceParser.RULE_tryBlock);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 527;
	        this.match(sequenceParser.TRY);
	        this.state = 528;
	        this.braceBlock();
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	catchBlock() {
	    let localctx = new CatchBlockContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 94, sequenceParser.RULE_catchBlock);
	    var _la = 0; // Token type
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 530;
	        this.match(sequenceParser.CATCH);
	        this.state = 532;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===33) {
	            this.state = 531;
	            this.invocation();
	        }

	        this.state = 534;
	        this.braceBlock();
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	finallyBlock() {
	    let localctx = new FinallyBlockContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 96, sequenceParser.RULE_finallyBlock);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 536;
	        this.match(sequenceParser.FINALLY);
	        this.state = 537;
	        this.braceBlock();
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	alt() {
	    let localctx = new AltContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 98, sequenceParser.RULE_alt);
	    var _la = 0; // Token type
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 539;
	        this.ifBlock();
	        this.state = 543;
	        this._errHandler.sync(this);
	        var _alt = this._interp.adaptivePredict(this._input,86,this._ctx)
	        while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
	            if(_alt===1) {
	                this.state = 540;
	                this.elseIfBlock(); 
	            }
	            this.state = 545;
	            this._errHandler.sync(this);
	            _alt = this._interp.adaptivePredict(this._input,86,this._ctx);
	        }

	        this.state = 547;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===41) {
	            this.state = 546;
	            this.elseBlock();
	        }

	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	ifBlock() {
	    let localctx = new IfBlockContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 100, sequenceParser.RULE_ifBlock);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 549;
	        this.match(sequenceParser.IF);
	        this.state = 550;
	        this.parExpr();
	        this.state = 552;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,88,this._ctx);
	        if(la_===1) {
	            this.state = 551;
	            this.braceBlock();

	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	elseIfBlock() {
	    let localctx = new ElseIfBlockContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 102, sequenceParser.RULE_elseIfBlock);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 554;
	        this.match(sequenceParser.ELSE);
	        this.state = 555;
	        this.match(sequenceParser.IF);
	        this.state = 556;
	        this.parExpr();
	        this.state = 558;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,89,this._ctx);
	        if(la_===1) {
	            this.state = 557;
	            this.braceBlock();

	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	elseBlock() {
	    let localctx = new ElseBlockContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 104, sequenceParser.RULE_elseBlock);
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 560;
	        this.match(sequenceParser.ELSE);
	        this.state = 562;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,90,this._ctx);
	        if(la_===1) {
	            this.state = 561;
	            this.braceBlock();

	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	braceBlock() {
	    let localctx = new BraceBlockContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 106, sequenceParser.RULE_braceBlock);
	    var _la = 0; // Token type
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 564;
	        this.match(sequenceParser.OBRACE);
	        this.state = 566;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(((((_la - 13)) & ~0x1f) == 0 && ((1 << (_la - 13)) & 4013948929) !== 0) || ((((_la - 45)) & ~0x1f) == 0 && ((1 << (_la - 45)) & 2222952637) !== 0)) {
	            this.state = 565;
	            this.block();
	        }

	        this.state = 568;
	        this.match(sequenceParser.CBRACE);
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	loop() {
	    let localctx = new LoopContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 108, sequenceParser.RULE_loop);
	    var _la = 0; // Token type
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 570;
	        this.match(sequenceParser.WHILE);
	        this.state = 572;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===33) {
	            this.state = 571;
	            this.parExpr();
	        }

	        this.state = 575;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,93,this._ctx);
	        if(la_===1) {
	            this.state = 574;
	            this.braceBlock();

	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}


	expr(_p) {
		if(_p===undefined) {
		    _p = 0;
		}
	    const _parentctx = this._ctx;
	    const _parentState = this.state;
	    let localctx = new ExprContext(this, this._ctx, _parentState);
	    let _prevctx = localctx;
	    const _startState = 110;
	    this.enterRecursionRule(localctx, 110, sequenceParser.RULE_expr, _p);
	    var _la = 0; // Token type
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 597;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,95,this._ctx);
	        switch(la_) {
	        case 1:
	            localctx = new AtomExprContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;

	            this.state = 578;
	            this.atom();
	            break;

	        case 2:
	            localctx = new UnaryMinusExprContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 579;
	            this.match(sequenceParser.MINUS);
	            this.state = 580;
	            this.expr(13);
	            break;

	        case 3:
	            localctx = new NotExprContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 581;
	            this.match(sequenceParser.NOT);
	            this.state = 582;
	            this.expr(12);
	            break;

	        case 4:
	            localctx = new FuncExprContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 586;
	            this._errHandler.sync(this);
	            var la_ = this._interp.adaptivePredict(this._input,94,this._ctx);
	            if(la_===1) {
	                this.state = 583;
	                this.to();
	                this.state = 584;
	                this.match(sequenceParser.DOT);

	            }
	            this.state = 588;
	            this.func();
	            break;

	        case 5:
	            localctx = new CreationExprContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 589;
	            this.creation();
	            break;

	        case 6:
	            localctx = new ParenthesizedExprContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 590;
	            this.match(sequenceParser.OPAR);
	            this.state = 591;
	            this.expr(0);
	            this.state = 592;
	            this.match(sequenceParser.CPAR);
	            break;

	        case 7:
	            localctx = new AssignmentExprContext(this, localctx);
	            this._ctx = localctx;
	            _prevctx = localctx;
	            this.state = 594;
	            this.assignment();
	            this.state = 595;
	            this.expr(1);
	            break;

	        }
	        this._ctx.stop = this._input.LT(-1);
	        this.state = 622;
	        this._errHandler.sync(this);
	        var _alt = this._interp.adaptivePredict(this._input,97,this._ctx)
	        while(_alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER) {
	            if(_alt===1) {
	                if(this._parseListeners!==null) {
	                    this.triggerExitRuleEvent();
	                }
	                _prevctx = localctx;
	                this.state = 620;
	                this._errHandler.sync(this);
	                var la_ = this._interp.adaptivePredict(this._input,96,this._ctx);
	                switch(la_) {
	                case 1:
	                    localctx = new MultiplicationExprContext(this, new ExprContext(this, _parentctx, _parentState));
	                    this.pushNewRecursionContext(localctx, _startState, sequenceParser.RULE_expr);
	                    this.state = 599;
	                    if (!( this.precpred(this._ctx, 11))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 11)");
	                    }
	                    this.state = 600;
	                    localctx.op = this._input.LT(1);
	                    _la = this._input.LA(1);
	                    if(!((((_la) & ~0x1f) == 0 && ((1 << _la) & 234881024) !== 0))) {
	                        localctx.op = this._errHandler.recoverInline(this);
	                    }
	                    else {
	                    	this._errHandler.reportMatch(this);
	                        this.consume();
	                    }
	                    this.state = 601;
	                    this.expr(12);
	                    break;

	                case 2:
	                    localctx = new AdditiveExprContext(this, new ExprContext(this, _parentctx, _parentState));
	                    this.pushNewRecursionContext(localctx, _startState, sequenceParser.RULE_expr);
	                    this.state = 602;
	                    if (!( this.precpred(this._ctx, 10))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 10)");
	                    }
	                    this.state = 603;
	                    localctx.op = this._input.LT(1);
	                    _la = this._input.LA(1);
	                    if(!(_la===23 || _la===24)) {
	                        localctx.op = this._errHandler.recoverInline(this);
	                    }
	                    else {
	                    	this._errHandler.reportMatch(this);
	                        this.consume();
	                    }
	                    this.state = 604;
	                    this.expr(11);
	                    break;

	                case 3:
	                    localctx = new RelationalExprContext(this, new ExprContext(this, _parentctx, _parentState));
	                    this.pushNewRecursionContext(localctx, _startState, sequenceParser.RULE_expr);
	                    this.state = 605;
	                    if (!( this.precpred(this._ctx, 9))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 9)");
	                    }
	                    this.state = 606;
	                    localctx.op = this._input.LT(1);
	                    _la = this._input.LA(1);
	                    if(!((((_la) & ~0x1f) == 0 && ((1 << _la) & 7864320) !== 0))) {
	                        localctx.op = this._errHandler.recoverInline(this);
	                    }
	                    else {
	                    	this._errHandler.reportMatch(this);
	                        this.consume();
	                    }
	                    this.state = 607;
	                    this.expr(10);
	                    break;

	                case 4:
	                    localctx = new EqualityExprContext(this, new ExprContext(this, _parentctx, _parentState));
	                    this.pushNewRecursionContext(localctx, _startState, sequenceParser.RULE_expr);
	                    this.state = 608;
	                    if (!( this.precpred(this._ctx, 8))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 8)");
	                    }
	                    this.state = 609;
	                    localctx.op = this._input.LT(1);
	                    _la = this._input.LA(1);
	                    if(!(_la===17 || _la===18)) {
	                        localctx.op = this._errHandler.recoverInline(this);
	                    }
	                    else {
	                    	this._errHandler.reportMatch(this);
	                        this.consume();
	                    }
	                    this.state = 610;
	                    this.expr(9);
	                    break;

	                case 5:
	                    localctx = new AndExprContext(this, new ExprContext(this, _parentctx, _parentState));
	                    this.pushNewRecursionContext(localctx, _startState, sequenceParser.RULE_expr);
	                    this.state = 611;
	                    if (!( this.precpred(this._ctx, 7))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 7)");
	                    }
	                    this.state = 612;
	                    this.match(sequenceParser.AND);
	                    this.state = 613;
	                    this.expr(8);
	                    break;

	                case 6:
	                    localctx = new OrExprContext(this, new ExprContext(this, _parentctx, _parentState));
	                    this.pushNewRecursionContext(localctx, _startState, sequenceParser.RULE_expr);
	                    this.state = 614;
	                    if (!( this.precpred(this._ctx, 6))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 6)");
	                    }
	                    this.state = 615;
	                    this.match(sequenceParser.OR);
	                    this.state = 616;
	                    this.expr(7);
	                    break;

	                case 7:
	                    localctx = new PlusExprContext(this, new ExprContext(this, _parentctx, _parentState));
	                    this.pushNewRecursionContext(localctx, _startState, sequenceParser.RULE_expr);
	                    this.state = 617;
	                    if (!( this.precpred(this._ctx, 5))) {
	                        throw new antlr4.error.FailedPredicateException(this, "this.precpred(this._ctx, 5)");
	                    }
	                    this.state = 618;
	                    this.match(sequenceParser.PLUS);
	                    this.state = 619;
	                    this.expr(6);
	                    break;

	                } 
	            }
	            this.state = 624;
	            this._errHandler.sync(this);
	            _alt = this._interp.adaptivePredict(this._input,97,this._ctx);
	        }

	    } catch( error) {
	        if(error instanceof antlr4.error.RecognitionException) {
		        localctx.exception = error;
		        this._errHandler.reportError(this, error);
		        this._errHandler.recover(this, error);
		    } else {
		    	throw error;
		    }
	    } finally {
	        this.unrollRecursionContexts(_parentctx)
	    }
	    return localctx;
	}



	atom() {
	    let localctx = new AtomContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 112, sequenceParser.RULE_atom);
	    var _la = 0; // Token type
	    try {
	        this.state = 633;
	        this._errHandler.sync(this);
	        switch(this._input.LA(1)) {
	        case 61:
	        case 62:
	            localctx = new NumberAtomContext(this, localctx);
	            this.enterOuterAlt(localctx, 1);
	            this.state = 625;
	            _la = this._input.LA(1);
	            if(!(_la===61 || _la===62)) {
	            this._errHandler.recoverInline(this);
	            }
	            else {
	            	this._errHandler.reportMatch(this);
	                this.consume();
	            }
	            break;
	        case 64:
	            localctx = new NumberUnitAtomContext(this, localctx);
	            this.enterOuterAlt(localctx, 2);
	            this.state = 626;
	            this.match(sequenceParser.NUMBER_UNIT);
	            break;
	        case 63:
	            localctx = new MoneyAtomContext(this, localctx);
	            this.enterOuterAlt(localctx, 3);
	            this.state = 627;
	            this.match(sequenceParser.MONEY);
	            break;
	        case 37:
	        case 38:
	            localctx = new BooleanAtomContext(this, localctx);
	            this.enterOuterAlt(localctx, 4);
	            this.state = 628;
	            _la = this._input.LA(1);
	            if(!(_la===37 || _la===38)) {
	            this._errHandler.recoverInline(this);
	            }
	            else {
	            	this._errHandler.reportMatch(this);
	                this.consume();
	            }
	            break;
	        case 60:
	            localctx = new IdAtomContext(this, localctx);
	            this.enterOuterAlt(localctx, 5);
	            this.state = 629;
	            this.match(sequenceParser.ID);
	            break;
	        case 65:
	            localctx = new DigitLeadingNameAtomContext(this, localctx);
	            this.enterOuterAlt(localctx, 6);
	            this.state = 630;
	            this.match(sequenceParser.DIGIT_LEADING_NAME);
	            break;
	        case 66:
	        case 67:
	            localctx = new StringAtomContext(this, localctx);
	            this.enterOuterAlt(localctx, 7);
	            this.state = 631;
	            _la = this._input.LA(1);
	            if(!(_la===66 || _la===67)) {
	            this._errHandler.recoverInline(this);
	            }
	            else {
	            	this._errHandler.reportMatch(this);
	                this.consume();
	            }
	            break;
	        case 39:
	            localctx = new NilAtomContext(this, localctx);
	            this.enterOuterAlt(localctx, 8);
	            this.state = 632;
	            this.match(sequenceParser.NIL);
	            break;
	        default:
	            throw new antlr4.error.NoViableAltException(this);
	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	parExpr() {
	    let localctx = new ParExprContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 114, sequenceParser.RULE_parExpr);
	    var _la = 0; // Token type
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 635;
	        this.match(sequenceParser.OPAR);
	        this.state = 637;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,99,this._ctx);
	        if(la_===1) {
	            this.state = 636;
	            this.condition();

	        }
	        this.state = 640;
	        this._errHandler.sync(this);
	        _la = this._input.LA(1);
	        if(_la===34) {
	            this.state = 639;
	            this.match(sequenceParser.CPAR);
	        }

	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	condition() {
	    let localctx = new ConditionContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 116, sequenceParser.RULE_condition);
	    try {
	        this.state = 646;
	        this._errHandler.sync(this);
	        var la_ = this._interp.adaptivePredict(this._input,101,this._ctx);
	        switch(la_) {
	        case 1:
	            this.enterOuterAlt(localctx, 1);
	            this.state = 642;
	            this.atom();
	            break;

	        case 2:
	            this.enterOuterAlt(localctx, 2);
	            this.state = 643;
	            this.expr(0);
	            break;

	        case 3:
	            this.enterOuterAlt(localctx, 3);
	            this.state = 644;
	            this.inExpr();
	            break;

	        case 4:
	            this.enterOuterAlt(localctx, 4);
	            this.state = 645;
	            this.textExpr();
	            break;

	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	inExpr() {
	    let localctx = new InExprContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 118, sequenceParser.RULE_inExpr);
	    var _la = 0; // Token type
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 648;
	        _la = this._input.LA(1);
	        if(!(_la===60 || _la===65)) {
	        this._errHandler.recoverInline(this);
	        }
	        else {
	        	this._errHandler.reportMatch(this);
	            this.consume();
	        }
	        this.state = 649;
	        this.match(sequenceParser.IN);
	        this.state = 650;
	        _la = this._input.LA(1);
	        if(!(_la===60 || _la===65)) {
	        this._errHandler.recoverInline(this);
	        }
	        else {
	        	this._errHandler.reportMatch(this);
	            this.consume();
	        }
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}



	textExpr() {
	    let localctx = new TextExprContext(this, this._ctx, this.state);
	    this.enterRule(localctx, 120, sequenceParser.RULE_textExpr);
	    var _la = 0; // Token type
	    try {
	        this.enterOuterAlt(localctx, 1);
	        this.state = 653; 
	        this._errHandler.sync(this);
	        var _alt = 1;
	        do {
	        	switch (_alt) {
	        	case 1:
	        		this.state = 652;
	        		_la = this._input.LA(1);
	        		if(!(((((_la - 60)) & ~0x1f) == 0 && ((1 << (_la - 60)) & 49) !== 0))) {
	        		this._errHandler.recoverInline(this);
	        		}
	        		else {
	        			this._errHandler.reportMatch(this);
	        		    this.consume();
	        		}
	        		break;
	        	default:
	        		throw new antlr4.error.NoViableAltException(this);
	        	}
	        	this.state = 655; 
	        	this._errHandler.sync(this);
	        	_alt = this._interp.adaptivePredict(this._input,102, this._ctx);
	        } while ( _alt!=2 && _alt!=antlr4.atn.ATN.INVALID_ALT_NUMBER );
	    } catch (re) {
	    	if(re instanceof antlr4.error.RecognitionException) {
		        localctx.exception = re;
		        this._errHandler.reportError(this, re);
		        this._errHandler.recover(this, re);
		    } else {
		    	throw re;
		    }
	    } finally {
	        this.exitRule();
	    }
	    return localctx;
	}


}

sequenceParser.EOF = antlr4.Token.EOF;
sequenceParser.WS = 1;
sequenceParser.CONSTANT = 2;
sequenceParser.READONLY = 3;
sequenceParser.STATIC = 4;
sequenceParser.AWAIT = 5;
sequenceParser.TITLE = 6;
sequenceParser.COL = 7;
sequenceParser.SOPEN = 8;
sequenceParser.SCLOSE = 9;
sequenceParser.RETURN_ARROW = 10;
sequenceParser.ARROW = 11;
sequenceParser.COLOR = 12;
sequenceParser.LBRACKET = 13;
sequenceParser.RBRACKET = 14;
sequenceParser.OR = 15;
sequenceParser.AND = 16;
sequenceParser.EQ = 17;
sequenceParser.NEQ = 18;
sequenceParser.GT = 19;
sequenceParser.LT = 20;
sequenceParser.GTEQ = 21;
sequenceParser.LTEQ = 22;
sequenceParser.PLUS = 23;
sequenceParser.MINUS = 24;
sequenceParser.MULT = 25;
sequenceParser.DIV = 26;
sequenceParser.MOD = 27;
sequenceParser.POW = 28;
sequenceParser.NOT = 29;
sequenceParser.SCOL = 30;
sequenceParser.COMMA = 31;
sequenceParser.ASSIGN = 32;
sequenceParser.OPAR = 33;
sequenceParser.CPAR = 34;
sequenceParser.OBRACE = 35;
sequenceParser.CBRACE = 36;
sequenceParser.TRUE = 37;
sequenceParser.FALSE = 38;
sequenceParser.NIL = 39;
sequenceParser.IF = 40;
sequenceParser.ELSE = 41;
sequenceParser.WHILE = 42;
sequenceParser.RETURN = 43;
sequenceParser.NEW = 44;
sequenceParser.PAR = 45;
sequenceParser.GROUP = 46;
sequenceParser.OPT = 47;
sequenceParser.CRITICAL = 48;
sequenceParser.SECTION = 49;
sequenceParser.REF = 50;
sequenceParser.AS = 51;
sequenceParser.TRY = 52;
sequenceParser.CATCH = 53;
sequenceParser.FINALLY = 54;
sequenceParser.IN = 55;
sequenceParser.STARTER_LXR = 56;
sequenceParser.ANNOTATION_RET = 57;
sequenceParser.ANNOTATION = 58;
sequenceParser.DOT = 59;
sequenceParser.ID = 60;
sequenceParser.INT = 61;
sequenceParser.FLOAT = 62;
sequenceParser.MONEY = 63;
sequenceParser.NUMBER_UNIT = 64;
sequenceParser.DIGIT_LEADING_NAME = 65;
sequenceParser.CSTRING = 66;
sequenceParser.USTRING = 67;
sequenceParser.CR = 68;
sequenceParser.COMMENT = 69;
sequenceParser.OTHER = 70;
sequenceParser.DIVIDER = 71;
sequenceParser.EVENT_PAYLOAD_LXR = 72;
sequenceParser.EVENT_END = 73;
sequenceParser.TITLE_CONTENT = 74;
sequenceParser.TITLE_END = 75;
sequenceParser.EMOJI_SHORTCODE = 76;

sequenceParser.RULE_prog = 0;
sequenceParser.RULE_title = 1;
sequenceParser.RULE_head = 2;
sequenceParser.RULE_group = 3;
sequenceParser.RULE_starterExp = 4;
sequenceParser.RULE_starter = 5;
sequenceParser.RULE_participant = 6;
sequenceParser.RULE_stereotype = 7;
sequenceParser.RULE_label = 8;
sequenceParser.RULE_participantType = 9;
sequenceParser.RULE_name = 10;
sequenceParser.RULE_width = 11;
sequenceParser.RULE_emoji = 12;
sequenceParser.RULE_block = 13;
sequenceParser.RULE_ret = 14;
sequenceParser.RULE_returnAsyncMessage = 15;
sequenceParser.RULE_divider = 16;
sequenceParser.RULE_dividerNote = 17;
sequenceParser.RULE_stat = 18;
sequenceParser.RULE_par = 19;
sequenceParser.RULE_opt = 20;
sequenceParser.RULE_critical = 21;
sequenceParser.RULE_section = 22;
sequenceParser.RULE_creation = 23;
sequenceParser.RULE_ref = 24;
sequenceParser.RULE_creationBody = 25;
sequenceParser.RULE_message = 26;
sequenceParser.RULE_messageBody = 27;
sequenceParser.RULE_fromTo = 28;
sequenceParser.RULE_func = 29;
sequenceParser.RULE_from = 30;
sequenceParser.RULE_to = 31;
sequenceParser.RULE_signature = 32;
sequenceParser.RULE_invocation = 33;
sequenceParser.RULE_assignment = 34;
sequenceParser.RULE_asyncMessage = 35;
sequenceParser.RULE_content = 36;
sequenceParser.RULE_construct = 37;
sequenceParser.RULE_type = 38;
sequenceParser.RULE_assignee = 39;
sequenceParser.RULE_methodName = 40;
sequenceParser.RULE_parameters = 41;
sequenceParser.RULE_parameter = 42;
sequenceParser.RULE_namedParameter = 43;
sequenceParser.RULE_declaration = 44;
sequenceParser.RULE_tcf = 45;
sequenceParser.RULE_tryBlock = 46;
sequenceParser.RULE_catchBlock = 47;
sequenceParser.RULE_finallyBlock = 48;
sequenceParser.RULE_alt = 49;
sequenceParser.RULE_ifBlock = 50;
sequenceParser.RULE_elseIfBlock = 51;
sequenceParser.RULE_elseBlock = 52;
sequenceParser.RULE_braceBlock = 53;
sequenceParser.RULE_loop = 54;
sequenceParser.RULE_expr = 55;
sequenceParser.RULE_atom = 56;
sequenceParser.RULE_parExpr = 57;
sequenceParser.RULE_condition = 58;
sequenceParser.RULE_inExpr = 59;
sequenceParser.RULE_textExpr = 60;

class ProgContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_prog;
    }

	EOF() {
	    return this.getToken(sequenceParser.EOF, 0);
	};

	title() {
	    return this.getTypedRuleContext(TitleContext,0);
	};

	head() {
	    return this.getTypedRuleContext(HeadContext,0);
	};

	block() {
	    return this.getTypedRuleContext(BlockContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterProg(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitProg(this);
		}
	}


}



class TitleContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_title;
    }

	TITLE() {
	    return this.getToken(sequenceParser.TITLE, 0);
	};

	TITLE_CONTENT() {
	    return this.getToken(sequenceParser.TITLE_CONTENT, 0);
	};

	TITLE_END() {
	    return this.getToken(sequenceParser.TITLE_END, 0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterTitle(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitTitle(this);
		}
	}


}



class HeadContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_head;
    }

	group = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(GroupContext);
	    } else {
	        return this.getTypedRuleContext(GroupContext,i);
	    }
	};

	participant = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ParticipantContext);
	    } else {
	        return this.getTypedRuleContext(ParticipantContext,i);
	    }
	};

	starterExp() {
	    return this.getTypedRuleContext(StarterExpContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterHead(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitHead(this);
		}
	}


}



class GroupContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_group;
    }

	GROUP() {
	    return this.getToken(sequenceParser.GROUP, 0);
	};

	name() {
	    return this.getTypedRuleContext(NameContext,0);
	};

	OBRACE() {
	    return this.getToken(sequenceParser.OBRACE, 0);
	};

	participant = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ParticipantContext);
	    } else {
	        return this.getTypedRuleContext(ParticipantContext,i);
	    }
	};

	CBRACE() {
	    return this.getToken(sequenceParser.CBRACE, 0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterGroup(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitGroup(this);
		}
	}


}



class StarterExpContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_starterExp;
    }

	STARTER_LXR() {
	    return this.getToken(sequenceParser.STARTER_LXR, 0);
	};

	OPAR() {
	    return this.getToken(sequenceParser.OPAR, 0);
	};

	CPAR() {
	    return this.getToken(sequenceParser.CPAR, 0);
	};

	starter() {
	    return this.getTypedRuleContext(StarterContext,0);
	};

	ANNOTATION() {
	    return this.getToken(sequenceParser.ANNOTATION, 0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterStarterExp(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitStarterExp(this);
		}
	}


}



class StarterContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_starter;
    }

	name() {
	    return this.getTypedRuleContext(NameContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterStarter(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitStarter(this);
		}
	}


}



class ParticipantContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_participant;
    }

	name() {
	    return this.getTypedRuleContext(NameContext,0);
	};

	participantType() {
	    return this.getTypedRuleContext(ParticipantTypeContext,0);
	};

	stereotype() {
	    return this.getTypedRuleContext(StereotypeContext,0);
	};

	emoji() {
	    return this.getTypedRuleContext(EmojiContext,0);
	};

	width() {
	    return this.getTypedRuleContext(WidthContext,0);
	};

	label() {
	    return this.getTypedRuleContext(LabelContext,0);
	};

	COLOR() {
	    return this.getToken(sequenceParser.COLOR, 0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterParticipant(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitParticipant(this);
		}
	}


}



class StereotypeContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_stereotype;
    }

	SOPEN() {
	    return this.getToken(sequenceParser.SOPEN, 0);
	};

	name() {
	    return this.getTypedRuleContext(NameContext,0);
	};

	SCLOSE() {
	    return this.getToken(sequenceParser.SCLOSE, 0);
	};

	GT() {
	    return this.getToken(sequenceParser.GT, 0);
	};

	LT() {
	    return this.getToken(sequenceParser.LT, 0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterStereotype(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitStereotype(this);
		}
	}


}



class LabelContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_label;
    }

	AS() {
	    return this.getToken(sequenceParser.AS, 0);
	};

	name() {
	    return this.getTypedRuleContext(NameContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterLabel(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitLabel(this);
		}
	}


}



class ParticipantTypeContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_participantType;
    }

	ANNOTATION() {
	    return this.getToken(sequenceParser.ANNOTATION, 0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterParticipantType(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitParticipantType(this);
		}
	}


}



class NameContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_name;
    }

	ID() {
	    return this.getToken(sequenceParser.ID, 0);
	};

	DIGIT_LEADING_NAME() {
	    return this.getToken(sequenceParser.DIGIT_LEADING_NAME, 0);
	};

	CSTRING() {
	    return this.getToken(sequenceParser.CSTRING, 0);
	};

	USTRING() {
	    return this.getToken(sequenceParser.USTRING, 0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterName(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitName(this);
		}
	}


}



class WidthContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_width;
    }

	INT() {
	    return this.getToken(sequenceParser.INT, 0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterWidth(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitWidth(this);
		}
	}


}



class EmojiContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_emoji;
    }

	LBRACKET() {
	    return this.getToken(sequenceParser.LBRACKET, 0);
	};

	name() {
	    return this.getTypedRuleContext(NameContext,0);
	};

	RBRACKET() {
	    return this.getToken(sequenceParser.RBRACKET, 0);
	};

	EMOJI_SHORTCODE() {
	    return this.getToken(sequenceParser.EMOJI_SHORTCODE, 0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterEmoji(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitEmoji(this);
		}
	}


}



class BlockContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_block;
    }

	stat = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(StatContext);
	    } else {
	        return this.getTypedRuleContext(StatContext,i);
	    }
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterBlock(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitBlock(this);
		}
	}


}



class RetContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_ret;
    }

	RETURN() {
	    return this.getToken(sequenceParser.RETURN, 0);
	};

	expr() {
	    return this.getTypedRuleContext(ExprContext,0);
	};

	SCOL() {
	    return this.getToken(sequenceParser.SCOL, 0);
	};

	ANNOTATION_RET() {
	    return this.getToken(sequenceParser.ANNOTATION_RET, 0);
	};

	asyncMessage() {
	    return this.getTypedRuleContext(AsyncMessageContext,0);
	};

	EVENT_END() {
	    return this.getToken(sequenceParser.EVENT_END, 0);
	};

	returnAsyncMessage() {
	    return this.getTypedRuleContext(ReturnAsyncMessageContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterRet(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitRet(this);
		}
	}


}



class ReturnAsyncMessageContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_returnAsyncMessage;
    }

	from() {
	    return this.getTypedRuleContext(FromContext,0);
	};

	RETURN_ARROW() {
	    return this.getToken(sequenceParser.RETURN_ARROW, 0);
	};

	to() {
	    return this.getTypedRuleContext(ToContext,0);
	};

	COL() {
	    return this.getToken(sequenceParser.COL, 0);
	};

	content() {
	    return this.getTypedRuleContext(ContentContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterReturnAsyncMessage(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitReturnAsyncMessage(this);
		}
	}


}



class DividerContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_divider;
    }

	dividerNote() {
	    return this.getTypedRuleContext(DividerNoteContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterDivider(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitDivider(this);
		}
	}


}



class DividerNoteContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_dividerNote;
    }

	DIVIDER() {
	    return this.getToken(sequenceParser.DIVIDER, 0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterDividerNote(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitDividerNote(this);
		}
	}


}



class StatContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_stat;
    }

	alt() {
	    return this.getTypedRuleContext(AltContext,0);
	};

	par() {
	    return this.getTypedRuleContext(ParContext,0);
	};

	opt() {
	    return this.getTypedRuleContext(OptContext,0);
	};

	critical() {
	    return this.getTypedRuleContext(CriticalContext,0);
	};

	section() {
	    return this.getTypedRuleContext(SectionContext,0);
	};

	ref() {
	    return this.getTypedRuleContext(RefContext,0);
	};

	loop() {
	    return this.getTypedRuleContext(LoopContext,0);
	};

	creation() {
	    return this.getTypedRuleContext(CreationContext,0);
	};

	message() {
	    return this.getTypedRuleContext(MessageContext,0);
	};

	asyncMessage() {
	    return this.getTypedRuleContext(AsyncMessageContext,0);
	};

	EVENT_END() {
	    return this.getToken(sequenceParser.EVENT_END, 0);
	};

	ret() {
	    return this.getTypedRuleContext(RetContext,0);
	};

	divider() {
	    return this.getTypedRuleContext(DividerContext,0);
	};

	tcf() {
	    return this.getTypedRuleContext(TcfContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterStat(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitStat(this);
		}
	}


}



class ParContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_par;
    }

	PAR() {
	    return this.getToken(sequenceParser.PAR, 0);
	};

	braceBlock() {
	    return this.getTypedRuleContext(BraceBlockContext,0);
	};

	parExpr() {
	    return this.getTypedRuleContext(ParExprContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterPar(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitPar(this);
		}
	}


}



class OptContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_opt;
    }

	OPT() {
	    return this.getToken(sequenceParser.OPT, 0);
	};

	braceBlock() {
	    return this.getTypedRuleContext(BraceBlockContext,0);
	};

	parExpr() {
	    return this.getTypedRuleContext(ParExprContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterOpt(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitOpt(this);
		}
	}


}



class CriticalContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_critical;
    }

	CRITICAL() {
	    return this.getToken(sequenceParser.CRITICAL, 0);
	};

	braceBlock() {
	    return this.getTypedRuleContext(BraceBlockContext,0);
	};

	parExpr() {
	    return this.getTypedRuleContext(ParExprContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterCritical(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitCritical(this);
		}
	}


}



class SectionContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_section;
    }

	SECTION() {
	    return this.getToken(sequenceParser.SECTION, 0);
	};

	braceBlock() {
	    return this.getTypedRuleContext(BraceBlockContext,0);
	};

	OPAR() {
	    return this.getToken(sequenceParser.OPAR, 0);
	};

	CPAR() {
	    return this.getToken(sequenceParser.CPAR, 0);
	};

	atom() {
	    return this.getTypedRuleContext(AtomContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterSection(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitSection(this);
		}
	}


}



class CreationContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_creation;
    }

	creationBody() {
	    return this.getTypedRuleContext(CreationBodyContext,0);
	};

	SCOL() {
	    return this.getToken(sequenceParser.SCOL, 0);
	};

	braceBlock() {
	    return this.getTypedRuleContext(BraceBlockContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterCreation(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitCreation(this);
		}
	}


}



class RefContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_ref;
    }

	REF() {
	    return this.getToken(sequenceParser.REF, 0);
	};

	OPAR() {
	    return this.getToken(sequenceParser.OPAR, 0);
	};

	CPAR() {
	    return this.getToken(sequenceParser.CPAR, 0);
	};

	name = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(NameContext);
	    } else {
	        return this.getTypedRuleContext(NameContext,i);
	    }
	};

	SCOL() {
	    return this.getToken(sequenceParser.SCOL, 0);
	};

	COMMA = function(i) {
		if(i===undefined) {
			i = null;
		}
	    if(i===null) {
	        return this.getTokens(sequenceParser.COMMA);
	    } else {
	        return this.getToken(sequenceParser.COMMA, i);
	    }
	};


	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterRef(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitRef(this);
		}
	}


}



class CreationBodyContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_creationBody;
    }

	NEW() {
	    return this.getToken(sequenceParser.NEW, 0);
	};

	construct() {
	    return this.getTypedRuleContext(ConstructContext,0);
	};

	assignment() {
	    return this.getTypedRuleContext(AssignmentContext,0);
	};

	OPAR() {
	    return this.getToken(sequenceParser.OPAR, 0);
	};

	CPAR() {
	    return this.getToken(sequenceParser.CPAR, 0);
	};

	parameters() {
	    return this.getTypedRuleContext(ParametersContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterCreationBody(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitCreationBody(this);
		}
	}


}



class MessageContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_message;
    }

	messageBody() {
	    return this.getTypedRuleContext(MessageBodyContext,0);
	};

	SCOL() {
	    return this.getToken(sequenceParser.SCOL, 0);
	};

	braceBlock() {
	    return this.getTypedRuleContext(BraceBlockContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterMessage(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitMessage(this);
		}
	}


}



class MessageBodyContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_messageBody;
    }

	assignment() {
	    return this.getTypedRuleContext(AssignmentContext,0);
	};

	fromTo() {
	    return this.getTypedRuleContext(FromToContext,0);
	};

	func() {
	    return this.getTypedRuleContext(FuncContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterMessageBody(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitMessageBody(this);
		}
	}


}



class FromToContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_fromTo;
    }

	to() {
	    return this.getTypedRuleContext(ToContext,0);
	};

	DOT() {
	    return this.getToken(sequenceParser.DOT, 0);
	};

	from() {
	    return this.getTypedRuleContext(FromContext,0);
	};

	ARROW() {
	    return this.getToken(sequenceParser.ARROW, 0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterFromTo(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitFromTo(this);
		}
	}


}



class FuncContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_func;
    }

	signature = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(SignatureContext);
	    } else {
	        return this.getTypedRuleContext(SignatureContext,i);
	    }
	};

	DOT = function(i) {
		if(i===undefined) {
			i = null;
		}
	    if(i===null) {
	        return this.getTokens(sequenceParser.DOT);
	    } else {
	        return this.getToken(sequenceParser.DOT, i);
	    }
	};


	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterFunc(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitFunc(this);
		}
	}


}



class FromContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_from;
    }

	name() {
	    return this.getTypedRuleContext(NameContext,0);
	};

	emoji() {
	    return this.getTypedRuleContext(EmojiContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterFrom(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitFrom(this);
		}
	}


}



class ToContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_to;
    }

	name() {
	    return this.getTypedRuleContext(NameContext,0);
	};

	emoji() {
	    return this.getTypedRuleContext(EmojiContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterTo(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitTo(this);
		}
	}


}



class SignatureContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_signature;
    }

	methodName() {
	    return this.getTypedRuleContext(MethodNameContext,0);
	};

	invocation() {
	    return this.getTypedRuleContext(InvocationContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterSignature(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitSignature(this);
		}
	}


}



class InvocationContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_invocation;
    }

	OPAR() {
	    return this.getToken(sequenceParser.OPAR, 0);
	};

	CPAR() {
	    return this.getToken(sequenceParser.CPAR, 0);
	};

	parameters() {
	    return this.getTypedRuleContext(ParametersContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterInvocation(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitInvocation(this);
		}
	}


}



class AssignmentContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_assignment;
    }

	assignee() {
	    return this.getTypedRuleContext(AssigneeContext,0);
	};

	ASSIGN() {
	    return this.getToken(sequenceParser.ASSIGN, 0);
	};

	type() {
	    return this.getTypedRuleContext(TypeContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterAssignment(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitAssignment(this);
		}
	}


}



class AsyncMessageContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_asyncMessage;
    }

	to() {
	    return this.getTypedRuleContext(ToContext,0);
	};

	COL() {
	    return this.getToken(sequenceParser.COL, 0);
	};

	from() {
	    return this.getTypedRuleContext(FromContext,0);
	};

	ARROW() {
	    return this.getToken(sequenceParser.ARROW, 0);
	};

	content() {
	    return this.getTypedRuleContext(ContentContext,0);
	};

	MINUS() {
	    return this.getToken(sequenceParser.MINUS, 0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterAsyncMessage(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitAsyncMessage(this);
		}
	}


}



class ContentContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_content;
    }

	EVENT_PAYLOAD_LXR() {
	    return this.getToken(sequenceParser.EVENT_PAYLOAD_LXR, 0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterContent(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitContent(this);
		}
	}


}



class ConstructContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_construct;
    }

	name() {
	    return this.getTypedRuleContext(NameContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterConstruct(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitConstruct(this);
		}
	}


}



class TypeContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_type;
    }

	name() {
	    return this.getTypedRuleContext(NameContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterType(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitType(this);
		}
	}


}



class AssigneeContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_assignee;
    }

	atom() {
	    return this.getTypedRuleContext(AtomContext,0);
	};

	ID = function(i) {
		if(i===undefined) {
			i = null;
		}
	    if(i===null) {
	        return this.getTokens(sequenceParser.ID);
	    } else {
	        return this.getToken(sequenceParser.ID, i);
	    }
	};


	DIGIT_LEADING_NAME = function(i) {
		if(i===undefined) {
			i = null;
		}
	    if(i===null) {
	        return this.getTokens(sequenceParser.DIGIT_LEADING_NAME);
	    } else {
	        return this.getToken(sequenceParser.DIGIT_LEADING_NAME, i);
	    }
	};


	COMMA = function(i) {
		if(i===undefined) {
			i = null;
		}
	    if(i===null) {
	        return this.getTokens(sequenceParser.COMMA);
	    } else {
	        return this.getToken(sequenceParser.COMMA, i);
	    }
	};


	CSTRING() {
	    return this.getToken(sequenceParser.CSTRING, 0);
	};

	USTRING() {
	    return this.getToken(sequenceParser.USTRING, 0);
	};

	NEW() {
	    return this.getToken(sequenceParser.NEW, 0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterAssignee(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitAssignee(this);
		}
	}


}



class MethodNameContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_methodName;
    }

	name() {
	    return this.getTypedRuleContext(NameContext,0);
	};

	emoji() {
	    return this.getTypedRuleContext(EmojiContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterMethodName(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitMethodName(this);
		}
	}


}



class ParametersContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_parameters;
    }

	parameter = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ParameterContext);
	    } else {
	        return this.getTypedRuleContext(ParameterContext,i);
	    }
	};

	COMMA = function(i) {
		if(i===undefined) {
			i = null;
		}
	    if(i===null) {
	        return this.getTokens(sequenceParser.COMMA);
	    } else {
	        return this.getToken(sequenceParser.COMMA, i);
	    }
	};


	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterParameters(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitParameters(this);
		}
	}


}



class ParameterContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_parameter;
    }

	namedParameter() {
	    return this.getTypedRuleContext(NamedParameterContext,0);
	};

	declaration() {
	    return this.getTypedRuleContext(DeclarationContext,0);
	};

	expr() {
	    return this.getTypedRuleContext(ExprContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterParameter(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitParameter(this);
		}
	}


}



class NamedParameterContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_namedParameter;
    }

	ASSIGN() {
	    return this.getToken(sequenceParser.ASSIGN, 0);
	};

	ID() {
	    return this.getToken(sequenceParser.ID, 0);
	};

	DIGIT_LEADING_NAME() {
	    return this.getToken(sequenceParser.DIGIT_LEADING_NAME, 0);
	};

	expr() {
	    return this.getTypedRuleContext(ExprContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterNamedParameter(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitNamedParameter(this);
		}
	}


}



class DeclarationContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_declaration;
    }

	type() {
	    return this.getTypedRuleContext(TypeContext,0);
	};

	ID() {
	    return this.getToken(sequenceParser.ID, 0);
	};

	DIGIT_LEADING_NAME() {
	    return this.getToken(sequenceParser.DIGIT_LEADING_NAME, 0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterDeclaration(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitDeclaration(this);
		}
	}


}



class TcfContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_tcf;
    }

	tryBlock() {
	    return this.getTypedRuleContext(TryBlockContext,0);
	};

	catchBlock = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(CatchBlockContext);
	    } else {
	        return this.getTypedRuleContext(CatchBlockContext,i);
	    }
	};

	finallyBlock() {
	    return this.getTypedRuleContext(FinallyBlockContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterTcf(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitTcf(this);
		}
	}


}



class TryBlockContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_tryBlock;
    }

	TRY() {
	    return this.getToken(sequenceParser.TRY, 0);
	};

	braceBlock() {
	    return this.getTypedRuleContext(BraceBlockContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterTryBlock(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitTryBlock(this);
		}
	}


}



class CatchBlockContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_catchBlock;
    }

	CATCH() {
	    return this.getToken(sequenceParser.CATCH, 0);
	};

	braceBlock() {
	    return this.getTypedRuleContext(BraceBlockContext,0);
	};

	invocation() {
	    return this.getTypedRuleContext(InvocationContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterCatchBlock(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitCatchBlock(this);
		}
	}


}



class FinallyBlockContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_finallyBlock;
    }

	FINALLY() {
	    return this.getToken(sequenceParser.FINALLY, 0);
	};

	braceBlock() {
	    return this.getTypedRuleContext(BraceBlockContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterFinallyBlock(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitFinallyBlock(this);
		}
	}


}



class AltContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_alt;
    }

	ifBlock() {
	    return this.getTypedRuleContext(IfBlockContext,0);
	};

	elseIfBlock = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ElseIfBlockContext);
	    } else {
	        return this.getTypedRuleContext(ElseIfBlockContext,i);
	    }
	};

	elseBlock() {
	    return this.getTypedRuleContext(ElseBlockContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterAlt(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitAlt(this);
		}
	}


}



class IfBlockContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_ifBlock;
    }

	IF() {
	    return this.getToken(sequenceParser.IF, 0);
	};

	parExpr() {
	    return this.getTypedRuleContext(ParExprContext,0);
	};

	braceBlock() {
	    return this.getTypedRuleContext(BraceBlockContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterIfBlock(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitIfBlock(this);
		}
	}


}



class ElseIfBlockContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_elseIfBlock;
    }

	ELSE() {
	    return this.getToken(sequenceParser.ELSE, 0);
	};

	IF() {
	    return this.getToken(sequenceParser.IF, 0);
	};

	parExpr() {
	    return this.getTypedRuleContext(ParExprContext,0);
	};

	braceBlock() {
	    return this.getTypedRuleContext(BraceBlockContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterElseIfBlock(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitElseIfBlock(this);
		}
	}


}



class ElseBlockContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_elseBlock;
    }

	ELSE() {
	    return this.getToken(sequenceParser.ELSE, 0);
	};

	braceBlock() {
	    return this.getTypedRuleContext(BraceBlockContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterElseBlock(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitElseBlock(this);
		}
	}


}



class BraceBlockContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_braceBlock;
    }

	OBRACE() {
	    return this.getToken(sequenceParser.OBRACE, 0);
	};

	CBRACE() {
	    return this.getToken(sequenceParser.CBRACE, 0);
	};

	block() {
	    return this.getTypedRuleContext(BlockContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterBraceBlock(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitBraceBlock(this);
		}
	}


}



class LoopContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_loop;
    }

	WHILE() {
	    return this.getToken(sequenceParser.WHILE, 0);
	};

	parExpr() {
	    return this.getTypedRuleContext(ParExprContext,0);
	};

	braceBlock() {
	    return this.getTypedRuleContext(BraceBlockContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterLoop(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitLoop(this);
		}
	}


}



class ExprContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_expr;
    }


	 
		copyFrom(ctx) {
			super.copyFrom(ctx);
		}

}


class AssignmentExprContext extends ExprContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	assignment() {
	    return this.getTypedRuleContext(AssignmentContext,0);
	};

	expr() {
	    return this.getTypedRuleContext(ExprContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterAssignmentExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitAssignmentExpr(this);
		}
	}


}

sequenceParser.AssignmentExprContext = AssignmentExprContext;

class FuncExprContext extends ExprContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	func() {
	    return this.getTypedRuleContext(FuncContext,0);
	};

	to() {
	    return this.getTypedRuleContext(ToContext,0);
	};

	DOT() {
	    return this.getToken(sequenceParser.DOT, 0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterFuncExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitFuncExpr(this);
		}
	}


}

sequenceParser.FuncExprContext = FuncExprContext;

class AtomExprContext extends ExprContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	atom() {
	    return this.getTypedRuleContext(AtomContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterAtomExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitAtomExpr(this);
		}
	}


}

sequenceParser.AtomExprContext = AtomExprContext;

class OrExprContext extends ExprContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	expr = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExprContext);
	    } else {
	        return this.getTypedRuleContext(ExprContext,i);
	    }
	};

	OR() {
	    return this.getToken(sequenceParser.OR, 0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterOrExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitOrExpr(this);
		}
	}


}

sequenceParser.OrExprContext = OrExprContext;

class AdditiveExprContext extends ExprContext {

    constructor(parser, ctx) {
        super(parser);
        this.op = null; // Token;
        super.copyFrom(ctx);
    }

	expr = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExprContext);
	    } else {
	        return this.getTypedRuleContext(ExprContext,i);
	    }
	};

	PLUS() {
	    return this.getToken(sequenceParser.PLUS, 0);
	};

	MINUS() {
	    return this.getToken(sequenceParser.MINUS, 0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterAdditiveExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitAdditiveExpr(this);
		}
	}


}

sequenceParser.AdditiveExprContext = AdditiveExprContext;

class RelationalExprContext extends ExprContext {

    constructor(parser, ctx) {
        super(parser);
        this.op = null; // Token;
        super.copyFrom(ctx);
    }

	expr = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExprContext);
	    } else {
	        return this.getTypedRuleContext(ExprContext,i);
	    }
	};

	LTEQ() {
	    return this.getToken(sequenceParser.LTEQ, 0);
	};

	GTEQ() {
	    return this.getToken(sequenceParser.GTEQ, 0);
	};

	LT() {
	    return this.getToken(sequenceParser.LT, 0);
	};

	GT() {
	    return this.getToken(sequenceParser.GT, 0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterRelationalExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitRelationalExpr(this);
		}
	}


}

sequenceParser.RelationalExprContext = RelationalExprContext;

class PlusExprContext extends ExprContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	expr = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExprContext);
	    } else {
	        return this.getTypedRuleContext(ExprContext,i);
	    }
	};

	PLUS() {
	    return this.getToken(sequenceParser.PLUS, 0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterPlusExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitPlusExpr(this);
		}
	}


}

sequenceParser.PlusExprContext = PlusExprContext;

class NotExprContext extends ExprContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	NOT() {
	    return this.getToken(sequenceParser.NOT, 0);
	};

	expr() {
	    return this.getTypedRuleContext(ExprContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterNotExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitNotExpr(this);
		}
	}


}

sequenceParser.NotExprContext = NotExprContext;

class UnaryMinusExprContext extends ExprContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	MINUS() {
	    return this.getToken(sequenceParser.MINUS, 0);
	};

	expr() {
	    return this.getTypedRuleContext(ExprContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterUnaryMinusExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitUnaryMinusExpr(this);
		}
	}


}

sequenceParser.UnaryMinusExprContext = UnaryMinusExprContext;

class CreationExprContext extends ExprContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	creation() {
	    return this.getTypedRuleContext(CreationContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterCreationExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitCreationExpr(this);
		}
	}


}

sequenceParser.CreationExprContext = CreationExprContext;

class ParenthesizedExprContext extends ExprContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	OPAR() {
	    return this.getToken(sequenceParser.OPAR, 0);
	};

	expr() {
	    return this.getTypedRuleContext(ExprContext,0);
	};

	CPAR() {
	    return this.getToken(sequenceParser.CPAR, 0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterParenthesizedExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitParenthesizedExpr(this);
		}
	}


}

sequenceParser.ParenthesizedExprContext = ParenthesizedExprContext;

class MultiplicationExprContext extends ExprContext {

    constructor(parser, ctx) {
        super(parser);
        this.op = null; // Token;
        super.copyFrom(ctx);
    }

	expr = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExprContext);
	    } else {
	        return this.getTypedRuleContext(ExprContext,i);
	    }
	};

	MULT() {
	    return this.getToken(sequenceParser.MULT, 0);
	};

	DIV() {
	    return this.getToken(sequenceParser.DIV, 0);
	};

	MOD() {
	    return this.getToken(sequenceParser.MOD, 0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterMultiplicationExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitMultiplicationExpr(this);
		}
	}


}

sequenceParser.MultiplicationExprContext = MultiplicationExprContext;

class EqualityExprContext extends ExprContext {

    constructor(parser, ctx) {
        super(parser);
        this.op = null; // Token;
        super.copyFrom(ctx);
    }

	expr = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExprContext);
	    } else {
	        return this.getTypedRuleContext(ExprContext,i);
	    }
	};

	EQ() {
	    return this.getToken(sequenceParser.EQ, 0);
	};

	NEQ() {
	    return this.getToken(sequenceParser.NEQ, 0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterEqualityExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitEqualityExpr(this);
		}
	}


}

sequenceParser.EqualityExprContext = EqualityExprContext;

class AndExprContext extends ExprContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	expr = function(i) {
	    if(i===undefined) {
	        i = null;
	    }
	    if(i===null) {
	        return this.getTypedRuleContexts(ExprContext);
	    } else {
	        return this.getTypedRuleContext(ExprContext,i);
	    }
	};

	AND() {
	    return this.getToken(sequenceParser.AND, 0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterAndExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitAndExpr(this);
		}
	}


}

sequenceParser.AndExprContext = AndExprContext;

class AtomContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_atom;
    }


	 
		copyFrom(ctx) {
			super.copyFrom(ctx);
		}

}


class BooleanAtomContext extends AtomContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	TRUE() {
	    return this.getToken(sequenceParser.TRUE, 0);
	};

	FALSE() {
	    return this.getToken(sequenceParser.FALSE, 0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterBooleanAtom(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitBooleanAtom(this);
		}
	}


}

sequenceParser.BooleanAtomContext = BooleanAtomContext;

class IdAtomContext extends AtomContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	ID() {
	    return this.getToken(sequenceParser.ID, 0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterIdAtom(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitIdAtom(this);
		}
	}


}

sequenceParser.IdAtomContext = IdAtomContext;

class MoneyAtomContext extends AtomContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	MONEY() {
	    return this.getToken(sequenceParser.MONEY, 0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterMoneyAtom(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitMoneyAtom(this);
		}
	}


}

sequenceParser.MoneyAtomContext = MoneyAtomContext;

class StringAtomContext extends AtomContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	CSTRING() {
	    return this.getToken(sequenceParser.CSTRING, 0);
	};

	USTRING() {
	    return this.getToken(sequenceParser.USTRING, 0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterStringAtom(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitStringAtom(this);
		}
	}


}

sequenceParser.StringAtomContext = StringAtomContext;

class NilAtomContext extends AtomContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	NIL() {
	    return this.getToken(sequenceParser.NIL, 0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterNilAtom(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitNilAtom(this);
		}
	}


}

sequenceParser.NilAtomContext = NilAtomContext;

class NumberAtomContext extends AtomContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	INT() {
	    return this.getToken(sequenceParser.INT, 0);
	};

	FLOAT() {
	    return this.getToken(sequenceParser.FLOAT, 0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterNumberAtom(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitNumberAtom(this);
		}
	}


}

sequenceParser.NumberAtomContext = NumberAtomContext;

class NumberUnitAtomContext extends AtomContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	NUMBER_UNIT() {
	    return this.getToken(sequenceParser.NUMBER_UNIT, 0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterNumberUnitAtom(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitNumberUnitAtom(this);
		}
	}


}

sequenceParser.NumberUnitAtomContext = NumberUnitAtomContext;

class DigitLeadingNameAtomContext extends AtomContext {

    constructor(parser, ctx) {
        super(parser);
        super.copyFrom(ctx);
    }

	DIGIT_LEADING_NAME() {
	    return this.getToken(sequenceParser.DIGIT_LEADING_NAME, 0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterDigitLeadingNameAtom(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitDigitLeadingNameAtom(this);
		}
	}


}

sequenceParser.DigitLeadingNameAtomContext = DigitLeadingNameAtomContext;

class ParExprContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_parExpr;
    }

	OPAR() {
	    return this.getToken(sequenceParser.OPAR, 0);
	};

	condition() {
	    return this.getTypedRuleContext(ConditionContext,0);
	};

	CPAR() {
	    return this.getToken(sequenceParser.CPAR, 0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterParExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitParExpr(this);
		}
	}


}



class ConditionContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_condition;
    }

	atom() {
	    return this.getTypedRuleContext(AtomContext,0);
	};

	expr() {
	    return this.getTypedRuleContext(ExprContext,0);
	};

	inExpr() {
	    return this.getTypedRuleContext(InExprContext,0);
	};

	textExpr() {
	    return this.getTypedRuleContext(TextExprContext,0);
	};

	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterCondition(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitCondition(this);
		}
	}


}



class InExprContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_inExpr;
    }

	IN() {
	    return this.getToken(sequenceParser.IN, 0);
	};

	ID = function(i) {
		if(i===undefined) {
			i = null;
		}
	    if(i===null) {
	        return this.getTokens(sequenceParser.ID);
	    } else {
	        return this.getToken(sequenceParser.ID, i);
	    }
	};


	DIGIT_LEADING_NAME = function(i) {
		if(i===undefined) {
			i = null;
		}
	    if(i===null) {
	        return this.getTokens(sequenceParser.DIGIT_LEADING_NAME);
	    } else {
	        return this.getToken(sequenceParser.DIGIT_LEADING_NAME, i);
	    }
	};


	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterInExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitInExpr(this);
		}
	}


}



class TextExprContext extends antlr4.ParserRuleContext {

    constructor(parser, parent, invokingState) {
        if(parent===undefined) {
            parent = null;
        }
        if(invokingState===undefined || invokingState===null) {
            invokingState = -1;
        }
        super(parent, invokingState);
        this.parser = parser;
        this.ruleIndex = sequenceParser.RULE_textExpr;
    }

	ID = function(i) {
		if(i===undefined) {
			i = null;
		}
	    if(i===null) {
	        return this.getTokens(sequenceParser.ID);
	    } else {
	        return this.getToken(sequenceParser.ID, i);
	    }
	};


	DIGIT_LEADING_NAME = function(i) {
		if(i===undefined) {
			i = null;
		}
	    if(i===null) {
	        return this.getTokens(sequenceParser.DIGIT_LEADING_NAME);
	    } else {
	        return this.getToken(sequenceParser.DIGIT_LEADING_NAME, i);
	    }
	};


	NUMBER_UNIT = function(i) {
		if(i===undefined) {
			i = null;
		}
	    if(i===null) {
	        return this.getTokens(sequenceParser.NUMBER_UNIT);
	    } else {
	        return this.getToken(sequenceParser.NUMBER_UNIT, i);
	    }
	};


	enterRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.enterTextExpr(this);
		}
	}

	exitRule(listener) {
	    if(listener instanceof sequenceParserListener ) {
	        listener.exitTextExpr(this);
		}
	}


}




sequenceParser.ProgContext = ProgContext; 
sequenceParser.TitleContext = TitleContext; 
sequenceParser.HeadContext = HeadContext; 
sequenceParser.GroupContext = GroupContext; 
sequenceParser.StarterExpContext = StarterExpContext; 
sequenceParser.StarterContext = StarterContext; 
sequenceParser.ParticipantContext = ParticipantContext; 
sequenceParser.StereotypeContext = StereotypeContext; 
sequenceParser.LabelContext = LabelContext; 
sequenceParser.ParticipantTypeContext = ParticipantTypeContext; 
sequenceParser.NameContext = NameContext; 
sequenceParser.WidthContext = WidthContext; 
sequenceParser.EmojiContext = EmojiContext; 
sequenceParser.BlockContext = BlockContext; 
sequenceParser.RetContext = RetContext; 
sequenceParser.ReturnAsyncMessageContext = ReturnAsyncMessageContext; 
sequenceParser.DividerContext = DividerContext; 
sequenceParser.DividerNoteContext = DividerNoteContext; 
sequenceParser.StatContext = StatContext; 
sequenceParser.ParContext = ParContext; 
sequenceParser.OptContext = OptContext; 
sequenceParser.CriticalContext = CriticalContext; 
sequenceParser.SectionContext = SectionContext; 
sequenceParser.CreationContext = CreationContext; 
sequenceParser.RefContext = RefContext; 
sequenceParser.CreationBodyContext = CreationBodyContext; 
sequenceParser.MessageContext = MessageContext; 
sequenceParser.MessageBodyContext = MessageBodyContext; 
sequenceParser.FromToContext = FromToContext; 
sequenceParser.FuncContext = FuncContext; 
sequenceParser.FromContext = FromContext; 
sequenceParser.ToContext = ToContext; 
sequenceParser.SignatureContext = SignatureContext; 
sequenceParser.InvocationContext = InvocationContext; 
sequenceParser.AssignmentContext = AssignmentContext; 
sequenceParser.AsyncMessageContext = AsyncMessageContext; 
sequenceParser.ContentContext = ContentContext; 
sequenceParser.ConstructContext = ConstructContext; 
sequenceParser.TypeContext = TypeContext; 
sequenceParser.AssigneeContext = AssigneeContext; 
sequenceParser.MethodNameContext = MethodNameContext; 
sequenceParser.ParametersContext = ParametersContext; 
sequenceParser.ParameterContext = ParameterContext; 
sequenceParser.NamedParameterContext = NamedParameterContext; 
sequenceParser.DeclarationContext = DeclarationContext; 
sequenceParser.TcfContext = TcfContext; 
sequenceParser.TryBlockContext = TryBlockContext; 
sequenceParser.CatchBlockContext = CatchBlockContext; 
sequenceParser.FinallyBlockContext = FinallyBlockContext; 
sequenceParser.AltContext = AltContext; 
sequenceParser.IfBlockContext = IfBlockContext; 
sequenceParser.ElseIfBlockContext = ElseIfBlockContext; 
sequenceParser.ElseBlockContext = ElseBlockContext; 
sequenceParser.BraceBlockContext = BraceBlockContext; 
sequenceParser.LoopContext = LoopContext; 
sequenceParser.ExprContext = ExprContext; 
sequenceParser.AtomContext = AtomContext; 
sequenceParser.ParExprContext = ParExprContext; 
sequenceParser.ConditionContext = ConditionContext; 
sequenceParser.InExprContext = InExprContext; 
sequenceParser.TextExprContext = TextExprContext; 
